import { Component, OnInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService'
import { Router, ActivatedRoute } from '@angular/router';
import { MatBottomSheet, MatDialog } from '@angular/material';
import { sessionStorage } from '../localstorage.service';
import { FormControl } from '@angular/forms'
import { Chart } from 'chart.js';
import * as moment from 'moment';

import * as Highcharts from 'highcharts/highmaps';
import { DatePipe } from '@angular/common';
import indiaMap from '../../assets/indiaMap';
import { ToastrManager } from 'ng6-toastr-notifications';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';
declare const L: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  styles: ['agm-map { height: 600px; width: 1000px; }'],
  providers: [DatePipe]
})


export class DashboardComponent implements OnInit
 {
  @ViewChild('mapElement') mapElement: ElementRef;





  myMap: any;
  map: any;
   hod: any = [];
  user = [];
    reportingOne = [];

  targetTilesData: any = {}
  today_date: any = new Date()
  currentFinancialYearTarget: any = {}
  currentMonthTarget: any = {}
  productCategoryReport: any = []
  financialYearSalesReport: any = []
  regionWiseReport: any = [];
  savingFlag: boolean = false;
  data: any = {};
  isChartVisible = false;
  monthyeardata:any
  Allusers: any = [];
  mappingLocationData: any = []
  salesMeterReport: any = {}
  visitMeterReport: any = {}
  segmentBrandWise: any = [];
  networkType: any = [];
  loader: boolean;
  financialYearSalesGrowth: any = [];
  multiStackedConfig: any = []
  // charts
  latitude = 28.148735;
  longitude = 77.332024;
  zoom = 5;
  mapType = 'roadmap';
  vbulletConfig: any;
  vbulletConfig2: any;
  horizontalBarChart: ZingchartAngular.graphset;
  horizontalBarChart2: ZingchartAngular.graphset;
  config: any;

  today: any = new Date();
  lastDay: any = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0).getDate()
  currentDay: any = this.today.getDate()
labels=['Dealer','test','sdsds','dsdsds','sdsds','sdsdsd']
Count_values=['212','3232','323','2232','333','12342']
  AttendanceCount: any;
  search: any;
  chartConfig: {
    type: string; title: { text: string; fontSize: number; padding: string; }; scaleX: { labels: string[]; item: { fontSize: number; }; }; plot: { barWidth: string; animation: { effect: string; }; valueBox: { visible: boolean; fontSize: number; }; }; series: { values: number[]; }[]; plotarea: {
      margin: string; // top, right, bottom, left
    }; height: string; // Set specific height to fit your container
    width: string; // Make it responsive
    overflow: string;
  };
  VisitCount: any;

  states: any = [];
  FocusVisitCount: any={};
  customerConfig: {
    type: string; title: { text: string; fontSize: number; padding: string; }; scaleX: { labels: string[]; item: { fontSize: number; }; }; plot: { barWidth: string; animation: { effect: string; }; valueBox: { visible: boolean; fontSize: number; }; }; series: {
      values: number[]; backgroundColor: string; // Base color (fallback)
      gradientColors: string; // Gradient from light green to dark green
      gradientStops: string; // Defines how the gradient blends
    }[]; plotarea: {
      margin: string; // top, right, bottom, left
    }; height: string; // Set specific height to fit your container
    width: string; // Make it responsive
    overflow: string;
  };
  customerNetworkCount: any;
  check_in_data: any=[];
  totalCustomerVisitPieChart: { type: string; backgroundColor: string; plot: { tooltip: { backgroundColor: string; borderWidth: string; fontSize: string; sticky: boolean; thousandsSeparator: string; }; valueBox: { type: string; text: string; placement: string; fontSize: string; }; animation: { effect: number; sequence: number; speed: number; }; backgroundColor: string; borderWidth: string; slice: number; }; plotarea: { margin: string; backgroundColor: string; borderRadius: string; borderWidth: string; }; series: { text: string; values: any[]; backgroundColor: string; lineColor: string; lineWidth: string; marker: { backgroundColor: string; }; }[]; noData: { text: string; alpha: number; backgroundColor: string; bold: boolean; fontSize: string; textAlpha: number; }; };
  CustomerNetwork: {};
  FocusVisits: {};
  CustomerVisits: {};
  attendanceStatus: {};
  subDepartmentDataStatus:{};
  subDepartmentDataCount: any={};
  mapLoader: boolean=false;
  address: string;

  ngOnInit() {
    setTimeout(() => {
      this.getindiaMap();


    }, 700);


  }
ngAfterViewInit() {
  // Remove credits after chart initialization
  setTimeout(() => {
    const credits = document.querySelector('.zc-credits');
    if (credits) {
      credits.remove();
    }
  }, 100);
}


  transectionValue: any = [100, 0, 25, 12, 25, 10, 100, 80, 25, 12, 25, 10];
  invoiceValue: any = [40000, 50000, 35000, 21000, 10000, 17000, 80000, 13000, 40000, 50000, 35000, 21000];
  collectionValue: any = [35000, 40000, 35000, 17000, 5000, 12000, 40000, 3000, 35000, 40000, 15000, 17000];

  // generatedCoupon: any = [40000, 50000, 35000, 21000, 10000, 17000, 80000, 13000, 40000, 50000, 35000, 21000];
  // scannedCoupon: any = [35000, 40000, 35000, 17000, 5000, 12000, 40000, 3000, 35000, 40000, 15000, 17000];

  invoiceValue1: any = [40000, 50000, 35000, 60000, 20000, 17000, 30000, 13000, 40000, 50000, 35000, 24000, 40000, 50000, 35000, 21000, 10000, 17000, 13000, 13000, 40000, 50000, 35000, 21000, 40000, 50000, 35000, 21000, 10000, 17000, 10000];
  collectionValue1: any = [35000, 40000, 35000, 17000, 5000, 12000, 25000, 3000, 35000, 40000, 15000, 18000, 35000, 40000, 35000, 17000, 5000, 12000, 10000, 3000, 35000, 40000, 15000, 17000, 35000, 40000, 35000, 17000, 10000, 17000, 10000];

  // items: any = [1000, 2000, 3000, 3400, 3000, 2000, 1000, 900, 1400, 2000, 3000, 4000, 5000, 4700, 3400, 3000, 2000, 1000, 900, 1400, 2000, 3000, 4000, 5000, 5400, 5000, 4800, 4500, 4200, 4000, 3800];
  // boxes: any = [500, 1000, 1500, 1700, 1500, 1000, 500, 600, 700, 1500, 2000, 2500, 2700, 2500, 1700, 1500, 1000, 500, 600, 700, 1500, 2000, 2500, 2700, 2500, 2500, 2000, 1800, 1500, 1200, 1000];
  salesusers: any = [
    { name: 'Prashant Kumar Sharma', empCode: 'EMP406', points: '5,000' },
    { name: 'Shivkant Tiwari', empCode: 'EMP407', points: '4,000' },
    { name: 'Akash Sharma', empCode: 'EMP408', points: '3,000' },
    { name: 'Jaspreet', empCode: 'EMP409', points: '2,000' },
    { name: 'Manish', empCode: 'EMP410', points: '1,500' },
    { name: 'Davinder Kaur', empCode: 'SPIL167', points: '1,000' },
    { name: 'Saurav Kaur', empCode: 'SPIL168', points: '800' },
  ]

  productSegments = [
    { name: 'Wall Paint', percent: '80' },
    { name: 'Unico PU', percent: '70' },
    { name: 'Thinner', percent: '60' },
    { name: 'Polyester', percent: '50' },
    { name: 'Others', percent: '40' },
    { name: 'Metal', percent: '30' },
    { name: 'Italian Pu', percent: '20' },
    { name: 'Copper', percent: '10' },
  ]

  bonusScheme = [
    { name: 'Contractor Bonus', percent: '80' },
    { name: 'Bonus Point 1', percent: '70' },
    { name: 'Bonus Point 2', percent: '60' },
    { name: 'Bonus Point 3', percent: '50' },
    { name: 'Bonus Point 4', percent: '40' },
    { name: 'Bonus Point 5', percent: '30' },
    { name: 'Bonus Point 6', percent: '20' },
    { name: 'Bonus Point 7', percent: '10' },
    { name: 'Bonus Point 8', percent: '8' },
  ]
  currentDate = new Date();
  constructor(public toast: ToastrManager, private bottomSheet:MatBottomSheet,public serve: DatabaseService, public dialog: MatDialog, public route: Router, private renderer: Renderer2, public session: sessionStorage) {
    setTimeout(() => {
      this.getNetworkType();
      // this.getAllusers('')
      // this.get_targetTilesData()
      // this.get_productCategoryReport()
      // this.get_financialYearSalesReport()
      // this.get_regionWiseReport()
      // this.get_salesMeter();
      // this.get_visitMeter();
      // this.get_segmentByPercent();
      // this.get_financialYearSalesGrowth()
      this.getAttendanceStatus();
      this.getFocusVisits();
      this.getCustomerVisits();
      this.getCustomerNetwork()
      this.getsubDepartmentData()
    }, 500);

  }

  // tabs = ['Sales','Map','CRM Leads'];
  tabs = ['Sales','Map','CRM Leads'];

  segment = [
    { 'state': 'Andhra Pradesh' },
    { 'state': 'Arunachal Pradesh' },
    { 'state': 'Assam' },
    { 'state': 'Bihar' },
    { 'state': 'Chhattisgarh' },
    { 'state': 'Goa' },
    { 'state': 'Gujarat' },
    { 'state': 'Haryana' },
    { 'state': 'Himachal Pradesh' },
    { 'state': 'Jharkhand' },
    { 'state': 'Karnataka' },
    { 'state': 'Kerala' },
    { 'state': 'Madhya Pradesh	' },
    { 'state': 'Maharashtra' },
    { 'state': 'Manipur' },
    { 'state': 'Meghalaya' },
    { 'state': 'Mizoram' },
    { 'state': 'Nagaland' },
    { 'state': 'Odisha' },
    { 'state': 'Punjab' },
    { 'state': 'Rajasthan' },
    { 'state': 'Sikkim' },
    { 'state': 'Tamil Nadu' },
    { 'state': 'Telangana' },
    { 'state': 'Tripura' },
    { 'state': 'Uttar Pradesh' },
    { 'state': 'Uttarakhand' },
    { 'state': 'West Bengal' },
  ]
  tabValue: any = 'Sales';

  getindiaMap() {
    let mapIndiaOpt: any = {
      chart: {
        map: indiaMap
      },

      title: {
        text: ''
      },


      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: 'bottom'
        }
      },

      colorAxis: {
        min: 0
      },

      series: [{
        data: [
          ['madhya pradesh', 10], ['uttar pradesh', 11], ['karnataka', 12],
          ['nagaland', 13], ['bihar', 14], ['lakshadweep', 15],
          ['andaman and nicobar', 16], ['assam', 17], ['west bengal', 18],
          ['puducherry', 19], ['daman and diu', 20], ['gujarat', 21],
          ['rajasthan', 22], ['dadara and nagar havelli', 23],
          ['chhattisgarh', 24], ['tamil nadu', 25], ['chandigarh', 26],
          ['punjab', 27], ['haryana', 28], ['andhra pradesh', 29],
          ['maharashtra', 30], ['himachal pradesh', 31], ['meghalaya', 32],
          ['kerala', 33], ['telangana', 34], ['mizoram', 35], ['tripura', 36],
          ['manipur', 37], ['arunanchal pradesh', 38], ['jharkhand', 39],
          ['goa', 40], ['nct of delhi', 41], ['odisha', 42],
          ['jammu and kashmir', 43], ['sikkim', 44], ['uttarakhand', 45]
        ],
        name: 'State Wise Sales Matrix',
        states: {
          hover: {
            color: '#BADA55'
          }
        },
        dataLabels: {
          enabled: true,
          format: '{point.name}'
        }
      }]
    }
    Highcharts.mapChart('indiaMapBox', mapIndiaOpt);
  }

  getAttendanceStatus(){
    this.serve.post_rqst({'search':this.attendanceStatus}, "Dashboard/attendanceData")
    .subscribe((result => {
      this.AttendanceCount = result['result'];


      this.totalAttendancePieChart = {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {
            backgroundColor: '#000',
            borderWidth: '0px',
            fontSize: '10px',
            sticky: true,
            thousandsSeparator: ',',
          },
          valueBox: {
            type: 'all',
            text: '%npv%',
            placement: 'in',
            fontSize: '8px',
          },
          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000,
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',
          slice: 40,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },

        series: [
          {
            text: 'leave',
            values: [this.AttendanceCount.leaveCount],
            backgroundColor: '#ffc300',
            lineColor: '#ffc300',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ffc300',
            },
          },
          {
            text: 'holiday',
            values: [this.AttendanceCount.holidayCount],
            backgroundColor: '#00b7ff',
            lineColor: '#00b7ff',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#00b7ff',
            },
          },
          {
            text: 'present',
            values: [this.AttendanceCount.presentCount],
            backgroundColor: '#00a54d',
            lineColor: '#009fb5',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#009fb5',
            },
          },
          {
            text: 'absent',
            values: [this.AttendanceCount.absentCount],
            backgroundColor: '#ff4b4a',
            lineColor: '#ff4b4a',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ff4b4a',
            },
          },
        ],

        // Adding labels to show total value and "Total" text
        labels: [
          {
            text: this.AttendanceCount.totalCount.toString(),  // Total value
            fontSize: '16px',
            fontColor: '#000',
            fontWeight: 'bold',
            x: '50%',
            y: '45%', // Slightly above center
            anchor: 'c',
          },
          {
            text: 'Total', // Label under the total number
            fontSize: '12px',
            fontColor: '#000',
            fontWeight: 'normal',
            x: '50%',
            y: '55%', // Slightly below center
            anchor: 'c',
          },
        ],

        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };


    }))
  }
//   getCustomerVisits() {
//   this.serve.post_rqst({ search: this.search }, "Dashboard/partyWiseVisitData")
//     .subscribe((result => {
//       this.VisitCount = result['result'];


//       this.chartConfig = {
//         type: 'bar',
//         title: {
//           text: 'Customer Visits',
//           fontSize: 14,
//           padding: '5px'
//         },
//         scaleX: {
//           labels: this.VisitCount.party,
//           item: {
//             fontSize: 11,
//              color: '#212121'
//           }
//         },
//         plot: {
//           barWidth: '40px',
//           animation: {
//             effect: 'ANIMATION_SLIDE_LEFT'
//           },
//           valueBox: {
//             visible: true,
//             fontSize: 10
//           }
//         },
//        series: [{
//   values: this.VisitCount.count,
//   backgroundColor: '#e8f5e9',         // Light green
//   gradientColors: '#a5d6a7 #26a69a',  // Green to Teal
//   gradientStops: '0.1 0.9'
// }],

//         plotarea: {
//           margin: '55px 35px 35px 100px'
//         },
//         height: '380px',
//         width: '100%',
//         overflow: 'hidden'
//       } as any; // <- alternatively cast the entire config as 'any' if needed
//     }));
// }

  getCustomerVisits() {
  this.serve.post_rqst({ search: this.CustomerVisits }, "Dashboard/partyWiseVisitData")
    .subscribe((result => {
      this.VisitCount = result['result'];

 this.totalCustomerVisitPieChart= {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {

            backgroundColor: '#000',
            borderWidth: '0px',
            fontSize: '10px',
            sticky: true,
            thousandsSeparator: ',',
          },
          valueBox:
          {
            type: 'all',
            text: '%npv%',
            placement: 'in',
            fontSize: '8px'
          },
          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',
          slice: 40,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },

        series: [


          {
            text: 'Dealer & Distributor Visits',
            values: [ this.VisitCount.distDealerCombineCount],
            backgroundColor: '#00a54d',
            lineColor: '#009fb5',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#009fb5',
            },
          },
          {
            text: 'Demand Generation Visits',
            values: [ this.VisitCount.otherCounts],
            backgroundColor: '#ff4b4a',
            lineColor: '#ff4b4a',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ff4b4a',
            },
          }

        ],
        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };

    }));
}

  getFocusVisits(){
    this.serve.post_rqst({'search': this.FocusVisits}, "Dashboard/focusDealerVisitData")
    .subscribe((result => {
      this.FocusVisitCount = result['result'];

      this.totalFocusDealerPieChart= {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {

            backgroundColor: '#000',
            borderWidth: '0px',
            fontSize: '10px',
            sticky: true,
            thousandsSeparator: ',',
          },
          valueBox:
          {
            type: 'all',
            text: '%npv%',
            placement: 'in',
            fontSize: '8px'
          },
          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',
          slice: 40,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },

        series: [


          {
            text: 'present',
            values: [this.FocusVisitCount.focusVisitCount],
            backgroundColor: '#00a54d',
            lineColor: '#009fb5',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#009fb5',
            },
          },
          {
            text: 'absent',
            values: [this.FocusVisitCount.noFocusVisitCount],
            backgroundColor: '#ff4b4a',
            lineColor: '#ff4b4a',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ff4b4a',
            },
          }

        ],
        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };


    }))
  }

  getCustomerNetwork(){
    this.serve.post_rqst({'search':this.CustomerNetwork}, "Dashboard/customerNetworkData")
    .subscribe((result => {
      this.customerNetworkCount = result['result'];

     // Create the base configuration object with strict typing
const baseConfig = {
  type: 'bar',
  title: {
    text: 'Customer Network',
    fontSize: 14,
    padding: '5px'
  },
  scaleX: {
    labels: this.customerNetworkCount.partyName,
    item: {
      fontSize: 9,
       color: '#000000'
    }
  },
  plot: {
    barWidth: '20px',
    animation: {
      effect: 'ANIMATION_SLIDE_LEFT'
    },
    valueBox: {
      visible: true,
      fontSize: 10
    },
  },
  series: [{
  values: this.customerNetworkCount.count,
  backgroundColor: 'rgba(0, 51, 102, 0.7)',
  gradientColors: '#1e3c72 #2a5298',
  gradientStops: '0.1 0.9'
}],
  plotarea: {
    margin: '55px 10px 130px 45px'
  },
  height: '380px',
  width: '100%',
  overflow: 'hidden'
};

// Process labels to insert line breaks for long text
const processedLabels = this.customerNetworkCount.partyName.map(label => {
  // If label is longer than 10 characters, insert line breaks
  if (label && label.length > 10) {
    // Split into chunks of approximately 10 characters at word boundaries if possible
    let result = '';
    let currentLine = '';

    // Split the label into words
    const words = label.split(' ');

    for (const word of words) {
      // If adding this word would make the line too long, add a line break
      if (currentLine.length + word.length > 10 && currentLine.length > 0) {
        result += currentLine + '\\n';
        currentLine = word;
      } else {
        // Otherwise, add the word to the current line
        if (currentLine.length > 0) {
          currentLine += ' ' + word;
        } else {
          currentLine = word;
        }
      }
    }

    // Add the last line
    result += currentLine;
    return result;
  }
  return label;
});

// Apply the full configuration with type assertion to bypass TypeScript checks
this.customerConfig = {
  ...baseConfig,
  scaleX: {
    ...baseConfig.scaleX,
    labels: processedLabels,
    color: '#000000',
    // Additional properties
    maxItems: 100,
    guide: {
      visible: true
    },
    // Text styling with additional offsets for multi-line labels
    item: {
      fontSize: 9,
      textAlign: 'center',
      wrapText: true,
      maxWidth: '80px',
      color: '#000000',
      angle: 0
    }
  }
} as any; // Use type assertion for the entire configuration
    }))
  }

 getsubDepartmentData(){
    this.serve.post_rqst({'search': this.subDepartmentDataStatus}, "Dashboard/subDepartmentData")
    .subscribe((result => {
      this.subDepartmentDataCount = result['result'];

      this.subDepartmentDataPieChart= {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {

            backgroundColor: '#000',
            borderWidth: '0px',
            fontSize: '10px',
            sticky: true,
            thousandsSeparator: ',',
          },
          valueBox:
          {
            type: 'all',
            text: '%npv%',
            placement: 'in',
            fontSize: '8px'
          },
          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',
          slice: 40,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },

        series: [


          {
            text: 'present',
            values: [this.subDepartmentDataCount.channelSales],
            backgroundColor: '#00a54d',
            lineColor: '#009fb5',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#009fb5',
            },
          },
          {
            text: 'absent',
            values: [this.subDepartmentDataCount.projectSales],
            backgroundColor: '#ff4b4a',
            lineColor: '#ff4b4a',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ff4b4a',
            },
          }

        ],
        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };


    }))
  }

  totalDays: any;
  dayInMonth: any;

  getTabValue(value) {
    this.tabValue = value.tab.textLabel;
    if (this.tabValue == 'Sales') {
      setTimeout(() => {
        // this.getindiaMap();
      }, 700);
    }

    if (this.tabValue == 'Map') {
      console.log("line 567")
    //  this.getMapData()
       this.userList('','')
    this.getAllList('', '', '', '','');

    }


    if (this.tabValue == 'Influencer Reward') {
      this.getInfluencerData();
      this.getThirtyDaysScanningItemBox();
      this.getCouponStatus();
      this.getTopInfluencer();
      this.getRegionInfluencer();
      this.getScanAgeing();
      this.getTopProductCategory();
      this.getTopBonusSchemeScanned();
      this.getScanningMeter();
      this.getPointReddemMeter();
      this.getTopInflucencerSource();

      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // Months are zero-based, so we add 1

      this.totalDays = new Date(year, month, 0).getDate();
      this.dayInMonth = currentDate.getDate();

    }


    if (this.tabValue == 'CRM Leads') {
      this.getTotalEnquiry('','');
      this.getEnquiryScore('','');
      this.getQualifiedEnquiry('','');
      this.getSourceWiseEnquiry('','');
      this.getSourceWiseConversion('','');
      this.getTopSalesUsers('','');
      this.getLeastSalesUser('','');
      this.getDataAccuracyRate('','');
      this.getcategoryWiseConversion('','');
      this.getLeadWiseConversion('','');
      this.getDisqualifiedEnquiry('','');
      this.get_leadWiseReport('','');
      this.getStateWiseEnquiry('','');
      setTimeout(() => {
      }, 700);
    }

    // if(this.tabValue == 'Sales'){
    //   setTimeout(() => {
    //   }, 700);
    // }

    // if(this.tabValue == 'Enquiry'){
    //   setTimeout(() => {
    //   }, 700);
    // }


  }



  openBottomSheet(type): void {
    this.bottomSheet.open(BottomSheetComponent, {
      data: {
        'filterPage': 'Dashboard',
      }
    });
    this.bottomSheet._openedBottomSheetRef.afterDismissed().subscribe((data) => {
   console.log(data)
   this.monthyeardata=data;
   console.log(this.monthyeardata)
   this.getTotalEnquiry(this.monthyeardata.month,this.monthyeardata.year);
   this.getEnquiryScore(this.monthyeardata.month,this.monthyeardata.year);
   this.getQualifiedEnquiry(this.monthyeardata.month,this.monthyeardata.year);
   this.getSourceWiseEnquiry(this.monthyeardata.month,this.monthyeardata.year);
   this.getSourceWiseConversion(this.monthyeardata.month,this.monthyeardata.year);
   this.getTopSalesUsers(this.monthyeardata.month,this.monthyeardata.year);
   this.getLeastSalesUser(this.monthyeardata.month,this.monthyeardata.year);
   this.getDataAccuracyRate(this.monthyeardata.month,this.monthyeardata.year);
   this.getcategoryWiseConversion(this.monthyeardata.month,this.monthyeardata.year);
   this.getLeadWiseConversion(this.monthyeardata.month,this.monthyeardata.year);
   this.getDisqualifiedEnquiry(this.monthyeardata.month,this.monthyeardata.year);
   this.get_leadWiseReport(this.monthyeardata.month,this.monthyeardata.year);
   this.getStateWiseEnquiry(this.monthyeardata.month,this.monthyeardata.year);
  //  this.StatewiseTarget(this.monthyeardata.month,this.monthyeardata.year);
  //  this.get_visitMeter(this.monthyeardata.month,this.monthyeardata.year);
  //  this.get_salesMeter(this.monthyeardata.month,this.monthyeardata.year);
  //  this.get_targetTilesData(this.monthyeardata.month,this.monthyeardata.year);



    })
  }
  SalesBottomSheet(type): void {
    this.bottomSheet.open(BottomSheetComponent, {
      data: {
        'filterPage': type,
        'filterType':type!='customerNetworkDashboard'?'dashboard':'',
        'filterValue':type=='attendanceDashboard'?this.attendanceStatus:type=='customerDashboard'?this.CustomerVisits:type=='focusDashboard'?this.FocusVisits:type=='customerNetworkDashboard'?this.CustomerNetwork:type=='subDepartmentData'?this.subDepartmentDataStatus:'' ,
      }
    });
    this.bottomSheet._openedBottomSheetRef.afterDismissed().subscribe((data) => {

   console.log(data)
if(data){

   if(type=='attendanceDashboard')
   {
    this.attendanceStatus=data
    this.getAttendanceStatus();
   }
   if(type=='subDepartmentData')
   {
    this.subDepartmentDataStatus=data
    this.getsubDepartmentData();
   }
   if(type=='customerDashboard')
    {
      this.CustomerVisits=data
     this.getCustomerVisits();
    }
    if(type=='focusDashboard')
      {
        this.FocusVisits=data
        this.getFocusVisits();
      }
      if(type=='customerNetworkDashboard')
        {
           this.CustomerNetwork=data
          this.getCustomerNetwork()
        }
}





    })
  }

  getMarkerIcon(type,Count){
    if(Count==0){
      return'./assets/location/end_point.png';
    }

    else if( type==3){
return'./assets/location/interiordesigner.png';
    }
    else if(type==1){
      return './assets/location/fabricator1.png';
    }
    else if(type==13){
      return './assets/location/checkin.png';
    }
    else if(type==14){
      return './assets/location/location.png';
    }
    else if(type==15){
      return './assets/location/mover.png';
    }
    else if(type==16){
      return './assets/location/marker.png';
    }
    else if(type==18){
      return './assets/location/pointmarker.png';
    }
    else if(type==17){
      return './assets/location/imag.png';
    }
    else if(type==19){
      return './assets/location/type.png';
    }




  }


  getNetworkType() {
    this.serve.post_rqst('', "CustomerNetwork/distributionNetworkModule").subscribe((result => {
      this.networkType = result['modules'];
    }))
  }

  submitDetail() {
    this.savingFlag = true;
    if (this.data.date_from) {
      this.data.date_from = moment(this.data.date_from).format('YYYY-MM-DD');
    }
    if (this.data.date_to) {
      this.data.date_to = moment(this.data.date_to).format('YYYY-MM-DD');
    }
    this.serve.post_rqst(this.data, "Dashboard/checkin_count").subscribe((result => {
      this.loader = false;
      this.savingFlag = false;
      console.log('result is',result)
      this.mappingLocationData = result['result'];
      this.toast.successToastr(result['statusMsg']);

    }))

    console.log('foremdatra', this.data)
  }

  getAllusers(search) {
    this.serve.post_rqst({'search':search}, 'Dashboard/userlist').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.Allusers = resp['result'];
        console.log(this.Allusers)
      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, err => {
      this.toast.errorToastr('Something went wrong');
    })
  }



  get_targetTilesData() {
    this.serve.post_rqst({}, 'Dashboard/sales').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.targetTilesData = resp['TargetData'];
        this.currentMonthTarget = this.targetTilesData.current_month_target
        this.currentFinancialYearTarget = this.targetTilesData.current_financial_year_target
      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, err => {
      this.toast.errorToastr('Something went wrong');
    })
  }

  get_productCategoryReport() {
    this.serve.post_rqst({}, 'Dashboard/productCategoryReport').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.productCategoryReport = resp['brandData'];
        let brandList = []
        let achieveList = []
        let targetList = []
        let percentList = []
        this.productCategoryReport.map((row, i) => {
          brandList[i] = row.brand;
          achieveList[i] = row.achieve;
          targetList[i] = row.target
          percentList[i] = row.percent
        })

        // this.vbulletConfig = {
        //   type: 'vbullet',
        //   title: {
        //     text: '',
        //   },
        //   plot: {
        //     tooltip: {
        //       borderRadius: '3px',
        //       borderWidth: '1px',
        //       fontSize: '14px',
        //       shadow: true,
        //     },
        //     animation: {
        //       effect: 4,
        //       method: 0,
        //       speed: 1600,
        //     },
        //     valueBox:
        //     {
        //       type: 'all',
        //       text: '%node-goal-value',
        //       angle: 0,
        //       color: '#000',
        //       placement: 'goal',
        //     },
        //   },
        //   backgroundColor: 'transparent',
        //   plotarea: {
        //     backgroundColor: 'transparent'
        //   },
        //   scaleX: {
        //     labels: brandList,
        //   },
        //   series: [
        //     {
        //       values: achieveList,
        //       dataDragging: true,
        //       goal: {
        //         borderWidth: '1px',
        //         height: 0,
        //         borderColor: '#000'
        //       },
        //       goals: targetList,
        //       rules: [
        //         {
        //           backgroundColor: '#64b5f6',
        //           rule: '%v >= %g',
        //         },
        //         {
        //           backgroundColor: '#bfbfbf',
        //           rule: '%v < %g',
        //         }
        //       ],
        //     },
        //   ],
        // };
      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, err => {
      this.toast.errorToastr('Something went wrong');
    })
  }

  get_financialYearSalesReport() {
    this.serve.post_rqst({}, 'Dashboard/financialYearSalesReport').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.financialYearSalesReport = resp['result'];
        let yearList = []
        let achieveList = []
        let targetList = []
        let monthList = []
        this.financialYearSalesReport.map((row, i) => {
          yearList[i] = row.year;
          achieveList[i] = row.achieve;
          targetList[i] = row.target;
          monthList[i] = row.month;
        })

        this.vbulletConfig2 = {
          type: 'vbullet',
          title: {
            text: '',
          },
          plot: {
            tooltip: {
              backgroundColor: 'black',
              borderRadius: '3px',
              borderWidth: '1px',
              fontSize: '14px',
              shadow: true,
            },
            animation: {
              effect: 4,
              method: 0,
              speed: 1600,
            },
            valueBox:
            {
              type: 'all',
              text: '%node-goal-value',
              'font-color': '#000',
              placement: 'goal',
            },
          },
          scaleX: {
            labels: monthList,
          },
          series: [
            {
              values: achieveList,
              dataDragging: true,
              goal: {
                backgroundColor: '#64b5f6',
                borderWidth: '1px',
                height: 0,
                borderColor: '#000'
              },
              goals: targetList,
              rules: [
                {
                  backgroundColor: '#009fb5',
                  rule: '%v >= %g',
                },
                {
                  backgroundColor: '#ef5350',
                  rule: '%v < %g/2',
                },
                {
                  backgroundColor: '#ffca28',
                  rule: '%v >= %g/2 && %v < %g',
                },
              ],
            },
          ],
        };

      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, err => {
      this.toast.errorToastr('Something went wrong');
    })
  }

  get_regionWiseReport() {
    // this.serve.post_rqst({}, 'Dashboard/regionWiseReport').subscribe((resp) => {
    //   if (resp['statusCode'] == 200) {
    //     this.regionWiseReport = resp['result'];
    //     let regionList = []
    //     let achieveList = []
    //     let targetList = []
    //     this.regionWiseReport.map((row, i) => {
    //       regionList[i] = row.region;
    //       achieveList[i] = row.achieve;
    //       targetList[i] = row.target;
    //     })

    //     this.horizontalBarChart = {
    //       type: "hbar",
    //       scaleX: {
    //         labels: regionList,
    //       },
    //       plot: {
    //         valueBox: {
    //           text: '%v',
    //           placement: "top-in",
    //           'font-color': "black",
    //           thousandsSeparator: ',',
    //         },
    //         animation: {
    //           effect: 11,
    //           speed: 3000,
    //         }
    //       },
    //       plotarea: {
    //         backgroundColor: 'transparent',
    //         marginTop: '0',
    //         marginRight: '15px',
    //         marginLeft: '80px'
    //       },
    //       series: [
    //         {
    //           values: achieveList,
    //           backgroundColor: '#00ccfd'
    //         },
    //         {
    //           values: targetList,
    //           backgroundColor: '#bac0c3'
    //         }
    //       ]
    //     };

    //   }
    //   else {
    //     this.toast.errorToastr(resp['statusMsg']);
    //   }
    // }, err => {
    //   this.toast.errorToastr('Something went wrong');
    // })
  }

  get_salesMeter() {
    console.log(this.lastDay)
    this.serve.post_rqst({}, 'Dashboard/salesMeter').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.salesMeterReport = resp['result'];

        this.config = {
          type: 'gauge',
          globals: {
            fontSize: '18px',
          },
          plot: {
            tooltip: {
              borderRadius: '5px',
              fontSize: '10px'
            },
            valueBox: {

              text: '%v',
              fontSize: '14px',
              placement: 'center',
              rules: [
                {
                  text: '%v<br>Days',
                  rule: '%v <= 30',
                },
              ],
            },
            size: '100%',
            animation: {
              effect: 11,
              speed: 3000,
            }
          },
          plotarea: {
            backgroundColor: 'transparent',
            marginTop: '40px',
          },
          scaleR: {
            "values": `0:${this.lastDay}:10`,
            aperture: 180,
            center: {
              visible: false,
            },
            item: {
              offsetR: 0,

            },
            labels: ['1', '', '', this.lastDay],
            maxValue: this.lastDay,
            minValue: 0,

            ring: {
              size: 50,
              backgroundColor: '#89b3d6',
              rules: [
                {
                  backgroundColor: '#89b3d6',
                  rule: '%v <= 10',
                },
                {
                  backgroundColor: '#009fb5',
                  rule: '%v >= 10 && %v <= 20',
                },
                {
                  backgroundColor: '#1a4262',
                  rule: '%v >= 20 && %v <= 30',
                },
              ],
            },
            step: 10,
            tick: {
              visible: false,
            },

          },

          refresh: {
            type: 'feed',
            url: 'feed()',
            interval: 1500,
            resetTimeout: 1000,
            transport: 'js',
          },
          series: [
            {
              values: [this.currentDay],
              backgroundColor: 'black',
              indicator: [0.1, 4, 5, 5, 0.3],

            },
          ],

        };

      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, err => {
      this.toast.errorToastr('Something went wrong');
    })
  }

  get_visitMeter(month,year) {
    this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/visitTargetReport').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.visitMeterReport = resp['result'];

        this.gaugeConfig = {
          type: 'gauge',
          globals: {
            fontSize: '18px',
          },
          plot: {
            tooltip: {
              borderRadius: '5px',
              fontSize: '10px'
            },
            valueBox: {
              text: '%v',
              fontSize: '14px',
              placement: 'center',
              rules: [
                {
                  text: '%v<br>Days',
                  rule: '%v <= 30',
                },
              ],
            },
            size: '100%',
          },
          plotarea: {
            backgroundColor: 'transparent',
            marginTop: '40px',
            fontSize: '10px'
          },
          scaleR: {
            "values": `0:${this.lastDay}:10`,
            aperture: 180,
            center: {
              visible: false,
            },
            item: {
              offsetR: 0,

            },
            labels: ['1', '', '', this.lastDay],
            maxValue: this.lastDay,
            minValue: 1,
            ring: {
              rules: [
                {
                  backgroundColor: '#b5a1c8',
                  rule: '%v <= 10',
                },
                {
                  backgroundColor: '#654779',
                  rule: '%v >= 10 && %v <= 20',
                },
                {
                  backgroundColor: '#433051',
                  rule: '%v >= 20 && %v <= 30',
                },
              ],
              size: '50px'
            },
            step: 10,
            tick: {
              visible: false,
            },
          },
          refresh: {
            type: 'feed',
            url: 'feed()',
            interval: 1500,
            resetTimeout: 1000,
            transport: 'js',
          },
          series: [
            {
              values: [this.currentDay],
              animation: {
                delay: 1200,
                effect: 2,
                method: 3,
                speed: 3000,
              },
              backgroundColor: 'black',
              indicator: [0.1, 4, 5, 5, 0.3],
            },
          ],


        };

      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, err => {
      this.toast.errorToastr('Something went wrong');
    })
  }

  get_segmentByPercent() {
    this.serve.post_rqst({}, 'Dashboard/segmentByPercent').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.segmentBrandWise = resp['brandData']
        this.segmentPieChart = {
          type: 'ring',
          backgroundColor: '#fff',

          plot: {
            tooltip: {
              backgroundColor: 'none',
              borderWidth: '0px',
              fontSize: '10px',

              sticky: true,
              thousandsSeparator: ',',

            },
            valueBox:
            {
              type: 'all',
              text: '%t<br>%npv%',
              placement: 'out',
              fontSize: '10px'
            },
            animation: {
              effect: 2,
              sequence: 3,
              speed: 1000
            },
            backgroundColor: '#FBFCFE',
            borderWidth: '0px',
            slice: 30,
          },
          plotarea: {
            margin: '0px',
            backgroundColor: 'transparent',
            borderRadius: '10px',
            borderWidth: '0px',
          },
          series: [
            {
              text: this.segmentBrandWise[0].brand,
              values: [this.segmentBrandWise[0].percent],
              backgroundColor: '#793e74',
              lineColor: '#00889f',
              lineWidth: '1px',
              marker: {
                backgroundColor: '#00889f',
              },
            },
            {
              text: this.segmentBrandWise[1].brand,
              values: [this.segmentBrandWise[1].percent],
              backgroundColor: '#cca79d',
              lineColor: '#00889f',
              lineWidth: '1px',
              marker: {
                backgroundColor: '#00889f',
              },
            },

          ],
          noData: {
            text: 'No Selection',
            alpha: 0.6,
            backgroundColor: '#20b2db',
            bold: true,
            fontSize: '10px',
            textAlpha: 0.9,
          },
        };


      }
      else {
        // this.toast.errorToastr(resp['statusMsg']);
      }
    }, err => {
      // this.toast.errorToastr('Something went wrong');
    })
  }



  get_financialYearSalesGrowth() {
    console.log(this.lastDay)
    this.serve.post_rqst({}, 'Dashboard/financialYearSalesGrowth').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.financialYearSalesGrowth = resp['result'];

        let yearList = []
        let achieveList = []
        let percentList = []
        let monthList = []
        this.financialYearSalesGrowth.map((row, i) => {
          yearList[i] = row.year;
          achieveList[i] = row.achieve;
          percentList[i] = row.percent;
          monthList[i] = row.month;
        })

        this.multiStackedConfig = {
          type: 'bar',
          stacked: true,
          title: {
            text: '',
            adjustLayout: true,
          },

          plot: {
            tooltip: {
              text: '%v%',
              borderRadius: '3px',
              fontColor: '#ffffff',

            },
            animation: {
              effect: 12,
              method: 0,
              speed: 1600,
            },


            valueBox: {
              text: '%total%',
              placement: "top-in",
              'font-color': "white",
              thousandsSeparator: ',',
              rules: [
                {
                  rule: '%stack-top == 0',
                  visible: false,
                },
              ],
            },
            offsetY: '-1px',
            rules: [
              {
                offsetY: '1px',
                rule: '%v <= 0',
              },
            ],
          },
          plotarea: {
            backgroundColor: 'transparent',
            margin: 'dynamic',
          },
          scaleX: {
            labels: yearList,
          },
          scaleY: {
            format: '%v',
            guide: {
              items: [
                {
                  backgroundColor: '#fff',
                }
              ],
            },
            multiplier: true,
            negation: 'currency',
            refLine: {
              lineColor: '#212121',
              lineWidth: '1px',
            },
          },
          series: [
            {
              text: 'Distributed Product',
              values: percentList,
              rules: [
                {
                  rule: '%v >= 0',
                  backgroundColor: '#00889f',
                },
                {
                  backgroundColor: '#ff4f3f',
                  rule: '%v < 0'
                }
              ],
              stack: 1,
            },
          ],

        };

      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, err => {
      this.toast.errorToastr('Something went wrong');
    })
  }

////////////////////////////////crm leads//////////////////////


totalEnquiry: any = {};
getTotalEnquiry(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/totalEnquiry').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.totalEnquiry = resp['result'];

      this.totalEnquiryPieChart = {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {
            backgroundColor: '#000',
            borderWidth: '0px',
            fontSize: '10px',
            sticky: true,
            thousandsSeparator: ',',
          },
          valueBox:
          {
            type: 'all',
            text: '%npv%',
            placement: 'in',
            fontSize: '8px'
          },
          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',
          slice: 40,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },

        series: [
          {
            text: 'Review Pending',
            values: [this.totalEnquiry.Pending],
            backgroundColor: '#ffc300',
            lineColor: '#ffc300',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ffc300',
            },
          },
          {
            text: 'Qualified',
            values: [this.totalEnquiry.Qualified],
            backgroundColor: '#00a54d',
            lineColor: '#009fb5',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#009fb5',
            },
          },
          {
            text: 'Disqualified',
            values: [this.totalEnquiry.Disqualified],
            backgroundColor: '#ff4b4a',
            lineColor: '#ff4b4a',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ff4b4a',
            },
          }

        ],
        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };


    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}

enquiryScoreData: any = {};
getEnquiryScore(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/enquiryScore').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.enquiryScoreData = resp['result'];
      this.enquiryScore = {
        type: 'gauge',
        globals: {
          fontSize: '18px',
        },
        plot: {
          tooltip: {
            borderRadius: '5px',
            fontSize: '10px'
          },
          valueBox: {
            text: '%v%',
            // text: '%v',
            fontSize: '18px',
            placement: 'center',
            rules: [
              {
                text: '%v',
                rule: '%v <= 30',
              },
            ],
          },
          size: '100%',
          animation: {
            effect: 11,
            speed: 3000,
          }
        },
        plotarea: {
          backgroundColor: 'transparent',
          marginTop: '40px',
        },
        scaleR: {
          aperture: 240,
          center: {
            visible: false,
          },
          item: {
            offsetR: 0,

          },
          labels: ['0', '', '', '', '100'],
          maxValue: 100,
          minValue: 0,
          ring: {
            rules: [
              {
                backgroundColor: '#ea4335',
                rule: '%v <= 25',
              },
              {
                backgroundColor: '#ffc300',
                rule: '%v >= 25 && %v <= 50',
              },
              {
                backgroundColor: '#2e7d32',
                rule: '%v > 50 && %v <= 100',
              },
            ],
            size: '20px',
          },
          step: 25,
          tick: {
            visible: false,
          },
        },
        refresh: {
          type: 'feed',
          url: 'feed()',
          interval: 1500,
          resetTimeout: 1000,
          transport: 'js',
        },
        series: [
          {
            values: [this.enquiryScoreData.Qualified],
            animation: {
              delay: 1200,
              effect: 2,
              method: 3,
              speed: 3000,
            },
            backgroundColor: 'black',
            indicator: [0.1, 4, 5, 5, 0.3],
          },
        ],

      };


    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}

qualifiedEnquiry: any = {};
getQualifiedEnquiry(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/qualifiedEnquiry').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.qualifiedEnquiry = resp['result'];
      this.qualifiedEnquiryPieChart = {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {
            backgroundColor: 'black',
            borderWidth: '0px',
            fontSize: '10px',

            sticky: true,

          },
          valueBox:
          {
            type: 'all',
            text: '%npv%',
            placement: 'in',
            fontSize: '8px'
          },

          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',
          slice: 40,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },

        series: [
          {
            text: 'Success',
            values: [this.qualifiedEnquiry.Success],
            backgroundColor: '#46a345',
            lineColor: '#46a345',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#46a345',
            },
          },
          {
            text: 'Rejected',
            values: [this.qualifiedEnquiry.Rejected],
            backgroundColor: '#ff4b4a',
            lineColor: '#ff4b4a',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ff4b4a',
            },
          },
          {
            text: 'In Process',
            values: [this.qualifiedEnquiry.Inprocess],
            backgroundColor: '#ffc300',
            lineColor: '#ffc300',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ffc300',
            },
          },
        ],
        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };



    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}


disqualifiedEnquiry: any = {};
getDisqualifiedEnquiry(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/disqualifiedEnquiry').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.disqualifiedEnquiry = resp['result'];
      this.disqualifiedMeter = {
        type: 'ring',
        backgroundColor: '#fff',
        plot: {
          tooltip: {

            backgroundColor: 'none',
            borderWidth: '0px',
            fontSize: '0px',
            visible: false,
            sticky: true,
          },
          valueBox:
          {
            type: 'min',
            text: '%v%',
            // text: `${parseInt(data[0]/(data[0]+data[1])*100)}%`,
            fontColor: '#718096',
            fontSize: '20px',
            placement: 'center',
            visible: true,
            offsetY: '25px',
          },
          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',

          slice: 50,
        },

        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },
        scaleR: {
          refAngle: 130,
          aperture: 280,
        },
        series: [
          {
            text: 'total',
            values: [this.disqualifiedEnquiry.Disqualified],
            // values: [20],
            backgroundColor: '#ff4b4a',
            lineColor: '#ff4b4a',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ff4b4a',
            },
          },
          // {
          //   text: 'total',
          //   values: [this.disqualifiedEnquiry.Total],
          //   backgroundColor: '#009fb5',
          //   lineColor: '#009fb5',
          //   lineWidth: '1px',
          //   marker: {
          //     backgroundColor: '#009fb5',
          //   },
          // },

        ],
        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };



    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}

leadWiseReport: any = [];
get_leadWiseReport(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/leadWiseReport').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.leadWiseReport = resp['result'];
      let regionList = []
      let winList = []
      let totalList = []
      this.leadWiseReport.map((row, i) => {
        regionList[i] = row.region;
        winList[i] = row.Win;
        totalList[i] = row.total;
      })

      this.horizontalBarChart2 = {
        type: "hbar",
        scaleX: {
          labels: regionList,
        },
        plot: {
          valueBox: {
            text: '%v',
            placement: "top-in",
            'font-color': "black",
            thousandsSeparator: ',',
          },
          animation: {
            effect: 11,
            speed: 3000,
          }
        },
        plotarea: {
          backgroundColor: 'transparent',
          marginTop: '0',
          marginRight: '15px',
          marginLeft: '80px'
        },
        series: [
          {
            values: winList,
            backgroundColor: '#00ccfd'
          },
          {
            values: totalList,
            backgroundColor: '#bac0c3'
          }
        ]
      };

    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}


stateWiseEnquiry: any = [];
getStateWiseEnquiry(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/stateWiseEnquiry').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.stateWiseEnquiry = resp['result'];

    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}



sourceWiseEnquiry: any = {};
getSourceWiseEnquiry(month,year) {
  this.serve.post_rqst({'month':month,'year':year}, 'Dashboard/sourceWiseEnquiry').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.sourceWiseEnquiry = resp['result'];
      let total = Math.ceil(this.sourceWiseEnquiry.Facebook + this.sourceWiseEnquiry.Website + this.sourceWiseEnquiry['Google Ads'] + this.sourceWiseEnquiry['Inbound/IVR']+ this.sourceWiseEnquiry['Toll Free'] + this.sourceWiseEnquiry['IndiaMart'] + this.sourceWiseEnquiry.Instagram + this.sourceWiseEnquiry['Mail'] + this.sourceWiseEnquiry.Others + this.sourceWiseEnquiry.Reference + this.sourceWiseEnquiry.Whatsapp + this.sourceWiseEnquiry.Call + this.sourceWiseEnquiry['Walk'] + this.sourceWiseEnquiry['Linked-in'] + this.sourceWiseEnquiry['SMS']+this.sourceWiseEnquiry.JustDial)
      this.sourceEnquiryPieChart = {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {

            backgroundColor: '#000',
            borderWidth: '0px',
            fontSize: '10px',
            sticky: true,
            thousandsSeparator: ',',
          },
          valueBox:
          {
            type: 'all',
            text: '%v%',
            placement: 'in',
            fontSize: '8px'
          },
          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',

          slice: 40,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },

        series: [
          {
            text: 'Facebook',
            values: [this.sourceWiseEnquiry.Facebook],
            backgroundColor: '#95ce50',
            lineColor: '#95ce50',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#95ce50',
            },
          },
          {
            text: 'Website',
            values: [this.sourceWiseEnquiry.Website],
            backgroundColor: '#ffb300',
            lineColor: '#ffb300',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ffb300',
            },
          },
          {
            text: 'Google',
            values: [this.sourceWiseEnquiry['Google Ads'] ],
            backgroundColor: '#ff6f00',
            lineColor: '#ff6f00',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ff6f00',
            },
          },
          {
            text: 'Inbound',
            values: [this.sourceWiseEnquiry['Inbound/IVR'] ],
            backgroundColor: '#00897b',
            lineColor: '#00897b',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#00897b',
            },
          },
          {
            text: 'Toll-Free',
            values: [this.sourceWiseEnquiry['Toll Free']],
            backgroundColor: '#2e7d32',
            lineColor: '#2e7d32',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#2e7d32',
            },
          },
          {
            text: 'IndiaMart',
            values: [this.sourceWiseEnquiry.IndiaMart],
            backgroundColor: '#1c124f',
            lineColor: '#1c124f',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#1c124f',
            },
          },

          {
            text: 'Instagram',
            values: [this.sourceWiseEnquiry.Instagram],
            backgroundColor: '#f70474',
            lineColor: '#f70474',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#f70474',
            },
          },
          {
            text: 'Call',
            values: [this.sourceWiseEnquiry.Call ],
            backgroundColor: '#72acae',
            lineColor: '#72acae',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#72acae',
            },
          },
          {
            text: 'Walk',
            values: [this.sourceWiseEnquiry.JustDial ],
            backgroundColor: '#1dc0d9',
            lineColor: '#1dc0d9',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#1dc0d9',
            },
          },
          {
            text: 'Linked-in',
            values: [this.sourceWiseEnquiry['Linked-in']],
            backgroundColor: '#0077b5',
            lineColor: '#0077b5',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#0077b5',
            },
          },
          {
            text: 'SMS',
            values: [this.sourceWiseEnquiry['SMS']],
            backgroundColor: '#e10ec9',
            lineColor: '#e10ec9',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#e10ec9',
            },
          },
          {
            text: 'JustDial',
            values: [this.sourceWiseEnquiry.JustDial],
            backgroundColor: '#b9cf0e',
            lineColor: '#b9cf0e',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#b9cf0e',
            },
          },

          {
            text: 'Mail',
            values: [this.sourceWiseEnquiry['Mail']],
            backgroundColor: '#0077b5',
            lineColor: '#0077b5',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#0077b5',
            },
          },
          {
            text: 'Reference',
            values: [this.sourceWiseEnquiry.Reference],
            backgroundColor: '#d778b3',
            lineColor: '#d778b3',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#d778b3',
            },
          },
          {
            text: 'Whatsapp',
            values: [this.sourceWiseEnquiry.Whatsapp],
            backgroundColor: '#1bd741',
            lineColor: '#1bd741',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#1bd741',
            },
          },
          {
            text: 'Others',
            values: [this.sourceWiseEnquiry.Others ],
            backgroundColor: '#ea4335',
            lineColor: '#ea4335',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ea4335',
            },
          },

        ],

        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };


    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}
sourceWiseConversion: any = {};
getSourceWiseConversion(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/sourceWiseConversion').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.sourceWiseConversion = resp['result'];

      this.sourceleadConfig = {
        type: 'bar',
        plot: {
          barWidth: '25px',
          tooltip: {
            borderRadius: '3px',
            borderWidth: '1px',
            fontSize: '14px',
            shadow: true,
          },
          animation: {
            effect: 4,
            method: 0,
            speed: 1600,
          },
          valueBox:
          {
            type: 'all',
            placement: "top-in",
            text: '%v%',
            // text: '%v',
            angle: 0,
            fontSize: '10px',
            fontWeight: '100',
            "font-color": "white",

          },
        },


        scaleX: {
          labels: ['Facebook', 'Website', 'Google Ads', 'Inbound/IVR', 'IndiaMart', 'Mail', 'Others', 'Reference', 'Toll Free', 'Whatsapp', 'Instagram','Call','JustDial','Linked-in','SMS','Walk']},


        series: [
          {
            // ff6f00
            // ffb300
            // ff6f00
            // 00897b
            // 43a047

            values: [this.sourceWiseConversion.Facebook, this.sourceWiseConversion.Website, this.sourceWiseConversion['Google ds'], this.sourceWiseConversion['Inbound/IVR'], this.sourceWiseConversion.IndiaMart, this.sourceWiseConversion['Mail'],this.sourceWiseConversion.Others, this.sourceWiseConversion.Reference,this.sourceWiseConversion['Toll Free'],this.sourceWiseConversion.Whatsapp, this.sourceWiseConversion.Instagram,this.sourceWiseEnquiry.Call,this.sourceWiseEnquiry['Walk'],this.sourceWiseEnquiry['Linked-in'],this.sourceWiseEnquiry['SMS'],this.sourceWiseEnquiry['JustDial']],
            styles: [
              { backgroundColor: '#95ce50' },
              { backgroundColor: '#ffb300' },
              { backgroundColor: '#ff6f00' },
              { backgroundColor: '#00897b' },
              { backgroundColor: '#43a047' },
              { backgroundColor: '#2e7d32' },
              { backgroundColor: '#989c25' },
              { backgroundColor: '#f70474' },
              { backgroundColor: '#0077b5' },
              { backgroundColor: '#d778b3' },
              { backgroundColor: '#1bd741' },
              { backgroundColor: '#ea4335' },
              { backgroundColor: '#1c124f' },
            ],
          },

        ],

      };


    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}


getTopSalesUsers(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/topSalesUser').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.salesusers = resp['result'];
    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}

leastSalesUsers: any = [];
getLeastSalesUser(month,year) {
  this.serve.post_rqst({'month':month,'year':year}, 'Dashboard/leastSalesUser').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.leastSalesUsers = resp['result'];
    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}

dataAccuracy: any = {};
getDataAccuracyRate(month,year) {
  this.serve.post_rqst({'month':month,'year':year}, 'Dashboard/dataAccuracyRate').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.dataAccuracy = resp['result'];
      let totalPercent = this.dataAccuracy.accurate;

      this.accuracyLead = {
        type: 'gauge',
        globals: {
          fontSize: '20px',
        },
        plot: {
          tooltip: {
            borderRadius: '5px',
            fontSize: '10px'
          },
          valueBox: {
            text: '%v%',
            fontSize: '20px',
            placement: 'center',
            rules: [
              {
                text: '%v',
                rule: '%v <= 30',
              },
            ],
          },
          size: '100%',
          animation: {
            effect: 11,
            speed: 3000,
          }
        },
        plotarea: {
          backgroundColor: 'transparent',
          marginTop: '40px',
        },
        scaleR: {
          aperture: 240,
          center: {
            visible: false,
          },
          item: {
            offsetR: 0,

          },
          labels: ['0', '', '', '', '100'],
          maxValue: 100,
          minValue: 0,
          ring: {
            rules: [
              {
                backgroundColor: '#ea4335',
                rule: '%v <= 25',
              },
              {
                backgroundColor: '#ffc300',
                rule: '%v >= 25 && %v <= 50',
              },
              {
                backgroundColor: '#2e7d32',
                rule: '%v > 50 && %v <= 100',
              },
            ],
            size: '25px',
          },
          step: 25,
          tick: {
            visible: false,
          },
        },
        refresh: {
          type: 'feed',
          url: 'feed()',
          interval: 1500,
          resetTimeout: 1000,
          transport: 'js',
        },
        series: [
          {
            values: [totalPercent],
            animation: {
              delay: 1200,
              effect: 2,
              method: 3,
              speed: 3000,
            },
            backgroundColor: 'black',
            indicator: [0.1, 4, 5, 5, 0.3],
          },
        ],

      };
    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}

categoryWise: any = {};
getcategoryWiseConversion(month,year) {
  this.serve.post_rqst({ 'month':month,'year':year}, 'Dashboard/categoryWiseEnquiry').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.categoryWise = resp['result'];
      let categoryHeader = ['Distributor','Dealer' ,'Architect' ,'Builder', 'Carpenter', 'Contractor','Fabricator','Interior Designer','OEM','Site'];
      let categoryData = [this.categoryWise.Distributor, this.categoryWise.Dealer, this.categoryWise.Architect, this.categoryWise.Builder, this.categoryWise.Carpenter,this.categoryWise.Contractor,this.categoryWise.Fabricator,this.categoryWise['Interior Designer'],this.categoryWise['OEM'],this.categoryWise.Site];

      this.categoryleadConfig = {
        type: 'bar',
        title: {
          text: '',
        },
        plot: {
          tooltip: {
            borderRadius: '3px',
            borderWidth: '1px',
            fontSize: '14px',
            shadow: true,
          },
          animation: {
            effect: 4,
            method: 0,
            speed: 1600,
          },
          valueBox:
          {
            type: 'all',
            placement: "top-in",
            // text: '%v%',
            text: '%v',
            angle: 0,
            fontSize: '10px',
            fontWeight: '100',
            "font-color": "white"
          },
        },
        scaleX: {
          labels: categoryHeader,
        },
        series: [
          {


            // values: [this.categoryWise['Direct Dealers'], this.categoryWise.Distributor, this.categoryWise.Plumber, this.categoryWise.Project, this.categoryWise.Retailer],
            values: categoryData,
            dataDragging: true,
            goal: {
              borderWidth: '1px',
              height: 0,
              borderColor: '#000'
            },
            goals: [25, 30, 30],
            styles: [
              { backgroundColor: '#989c25' },
              { backgroundColor: '#1d9379' },
              { backgroundColor: '#5df1cc' },
              { backgroundColor: '#7fceb7' },
              { backgroundColor: '#872a93' },
              { backgroundColor: '#a81ac6' },
              { backgroundColor: '#f70474' },
              { backgroundColor: '#0077b5' },
            ],
          },
        ],
      };


    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}



leadWiseCatgory: any = {};
getLeadWiseConversion(month,year) {
  this.serve.post_rqst({'month':month,'year':year}, 'Dashboard/categoryWiseConversion').subscribe((resp) => {
    if (resp['statusCode'] == 200) {
      this.leadWiseCatgory = resp['result'];
      this.leadPieChart = {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {
            backgroundColor: 'black',
            borderWidth: '0px',
            fontSize: '10px',

            sticky: true,
            thousandsSeparator: ',',
          },
          valueBox:
          {
            type: 'all',
            text: '%t<br>%npv%',
            placement: 'out',
            fontSize: '10px'
          },
          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',
          slice: 40,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },
        series: [
          {
            text: 'Direct Dealers',
            values: [this.leadWiseCatgory['Direct Dealers']],
            backgroundColor: '#26a0fc',
            lineColor: '#26a0fc',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#26a0fc',
            },
          },
          {
            text: 'Distributor',
            values: [this.leadWiseCatgory.Distributor],
            backgroundColor: '#68d4cd',
            lineColor: '#68d4cd',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#68d4cd',
            },
          },
          {
            text: 'Plumber',
            values: [this.leadWiseCatgory.Plumber],
            backgroundColor: '#ffc000',
            lineColor: '#ffc000',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ffc000',
            },
          },
          {
            text: 'Project',
            values: [this.leadWiseCatgory.Project],
            backgroundColor: '#ffc000',
            lineColor: '#ffc000',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ffc000',
            },
          },
          {
            text: 'Retailer',
            values: [this.leadWiseCatgory.Retailer],
            backgroundColor: '#ffc000',
            lineColor: '#ffc000',
            lineWidth: '1px',
            marker: {
              backgroundColor: '#ffc000',
            },
          },

        ],
        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };
      this.categoryleadConfig = {
        type: 'bar',
        title: {
          text: '',
        },
        plot: {
          tooltip: {
            borderRadius: '3px',
            borderWidth: '1px',
            fontSize: '14px',
            shadow: true,
          },
          animation: {
            effect: 4,
            method: 0,
            speed: 1600,
          },
          valueBox:
          {
            type: 'all',
            placement: "top-in",
            // text: '%v%',
            text: '%v',
            angle: 0,
            fontSize: '10px',
            fontWeight: '100',
            "font-color": "white"
          },
        },
        scaleX: {
          labels:['Distributor','Dealer' ,'Architect' ,'Builder', 'Carpenter', 'Contractor','Fabricator','Interior Designer','OEM','Site'],

          // labels: ['Direct Dealers', 'Distributor', 'Plumber', 'Project', 'Retailer'],
        },
        series: [
          {
            values:[this.categoryWise.Distributor, this.categoryWise.Dealer, this.categoryWise.Architect, this.categoryWise.Builder, this.categoryWise.Carpenter,this.categoryWise.Contractor,this.categoryWise.Fabricator,this.categoryWise['Interior Designer'],this.categoryWise['OEM'],this.categoryWise.Site],

            // values: [this.categoryWise['Direct Dealers'], this.categoryWise.Distributor, this.categoryWise.Plumber, this.categoryWise.Project, this.categoryWise.Retailer],
            dataDragging: true,
            goal: {
              borderWidth: '1px',
              height: 0,
              borderColor: '#000'
            },
            goals: [25, 30, 30],
            styles: [
              { backgroundColor: '#989c25' },
              { backgroundColor: '#1d9379' },
              { backgroundColor: '#5df1cc' },
              { backgroundColor: '#7fceb7' },
              { backgroundColor: '#872a93' },
              { backgroundColor: '#a81ac6' },
              { backgroundColor: '#f70474' },
              { backgroundColor: '#0077b5' },
            ],
          },
        ],
      };


    }
    else {
      this.toast.errorToastr(resp['statusMsg']);
    }
  }, err => {
    this.toast.errorToastr('Something went wrong');
  })
}

  /////////////////////////////influencers rewards/////////////


  totalInfluencerPieChart: any;
  influencerStatusPieChart: any;
  kycStatusPieChart: any;

  influencerWiseCount: any = [];
  influencerStatusWiseCount: any = [];
  redeemKycCount: any = [];
  couponCount: any = [];
  couponScanCount: any = [];
  getInfluencerData() {
    this.serve.get_rqst2({}, "LoyaltyDashboard/dashboard_count")
      .subscribe((result => {
        this.influencerWiseCount = result['influencer_wise_count'];
        let customerCount = parseInt(this.influencerWiseCount[0]['influencer_count']);
        let plumberCount = parseInt(this.influencerWiseCount[1]['influencer_count']);
        let totalInfluencer = parseInt(this.influencerWiseCount[2]['influencer_count']);


        this.influencerStatusWiseCount = result['influencer_status_wise_count'];
        let approvedCount = parseInt(this.influencerStatusWiseCount[0]['influencer_count']);
        let PendingCount = parseInt(this.influencerStatusWiseCount[1]['influencer_count']);
        let rejectCount = parseInt(this.influencerStatusWiseCount[2]['influencer_count']);

        this.redeemKycCount = result['redeem_kyc_count'];
        let kycPendingCount = parseInt(this.redeemKycCount[0]['redeem_kyc_count']);
        let reddemReqCount = parseInt(this.redeemKycCount[1]['redeem_kyc_count']);
        this.couponCount = result['coupon_count'];
        this.couponScanCount = result['coupon_scan_count'];

        this.totalInfluencerPieChart = {
          type: 'ring',
          backgroundColor: '#fff',

          plot: {
            tooltip: {

              backgroundColor: '#000',
              borderWidth: '0px',
              fontSize: '10px',
              sticky: true,
              thousandsSeparator: ',',
            },
            valueBox:
            {
              type: 'all',
              text: '%npv%',
              "offset-r": "-4%",
              fontSize: '8px',

            },
            animation: {
              effect: 2,
              sequence: 3,
              speed: 1000
            },
            backgroundColor: '#FBFCFE',
            borderWidth: '0px',
            slice: 0,
          },
          plotarea: {
            margin: '0px',
            backgroundColor: 'transparent',
            borderRadius: '10px',
            borderWidth: '0px',
          },

          series: [

            {
              text: 'Customer',
              values: [customerCount],
              backgroundColor: '#ffc409',
              lineColor: '#009fb5',
              lineWidth: '1px',
              marker: {
                backgroundColor: '#009fb5',
              },
            },
            {
              text: 'Plumber',
              values: [plumberCount],
              backgroundColor: '#007f39',
              lineColor: 'var(--warning)',
              lineWidth: '1px',
              marker: {
                backgroundColor: 'var(--warning)',
              },
            },
            {
              text: 'Total',
              values: [totalInfluencer],
              backgroundColor: '#02abe5',
              lineColor: 'var(--primary-tint)',
              lineWidth: '1px',
              marker: {
                backgroundColor: 'var(--primary-tint)',
              },
            },

          ],
          noData: {
            text: 'No Selection',
            alpha: 0.6,
            backgroundColor: '#20b2db',
            bold: true,
            fontSize: '10px',
            textAlpha: 0.9,
          },
        };

        this.influencerStatusPieChart = {
          type: 'ring',
          backgroundColor: '#fff',

          plot: {
            tooltip: {

              backgroundColor: '#000',
              borderWidth: '0px',
              fontSize: '10px',
              sticky: true,
              thousandsSeparator: ',',
            },
            valueBox:
            {
              type: 'all',
              text: '%npv%',
              placement: 'in',
              fontSize: '8px'
            },
            animation: {
              effect: 2,
              sequence: 3,
              speed: 1000
            },
            backgroundColor: '#FBFCFE',
            borderWidth: '0px',
            slice: 0,
          },
          plotarea: {
            margin: '0px',
            backgroundColor: 'transparent',
            borderRadius: '10px',
            borderWidth: '0px',
          },

          series: [
            {
              text: 'Pending',
              values: [PendingCount],
              backgroundColor: '#ffc300',
              lineColor: '#ffc300',
              lineWidth: '1px',
              marker: {
                backgroundColor: '#ffc300',
              },
            },
            {
              text: 'Approved',
              values: [approvedCount],
              backgroundColor: '#00a54d',
              lineColor: '#009fb5',
              lineWidth: '1px',
              marker: {
                backgroundColor: '#009fb5',
              },
            },
            {
              text: 'Reject',
              values: [rejectCount],
              backgroundColor: '#ff4b4a',
              lineColor: '#ff4b4a',
              lineWidth: '1px',
              marker: {
                backgroundColor: '#ff4b4a',
              },
            },
            // {
            //   text: 'Suspect',
            //   values: [10],
            //   backgroundColor: 'var(--secondary)',
            //   lineColor: 'var(--secondary)',
            //   lineWidth: '1px',
            //   marker: {
            //     backgroundColor: 'var(--secondary)',
            //   },
            // }

          ],
          noData: {
            text: 'No Selection',
            alpha: 0.6,
            backgroundColor: '#20b2db',
            bold: true,
            fontSize: '10px',
            textAlpha: 0.9,
          },
        };

        this.kycStatusPieChart = {
          type: 'ring',
          backgroundColor: '#fff',

          plot: {
            tooltip: {

              backgroundColor: '#000',
              borderWidth: '0px',
              fontSize: '10px',
              sticky: true,
              thousandsSeparator: ',',
            },
            valueBox:
            {
              type: 'all',
              text: '%npv%',
              placement: 'in',
              fontSize: '8px'
            },
            animation: {
              effect: 2,
              sequence: 3,
              speed: 1000
            },
            backgroundColor: '#FBFCFE',
            borderWidth: '0px',
            slice: 0,
          },
          plotarea: {
            margin: '0px',
            backgroundColor: 'transparent',
            borderRadius: '10px',
            borderWidth: '0px',
          },

          series: [
            {
              text: 'kYC Status',
              values: [kycPendingCount],
              backgroundColor: 'var(--warning)',
              lineColor: 'var(--warning)',
              lineWidth: '1px',
              marker: {
                backgroundColor: 'var(--warning)',
              },
            },
            {
              text: 'Redeem Request',
              values: [reddemReqCount],
              backgroundColor: 'var(--primary-tint)',
              lineColor: 'var(--primary-tint)',
              lineWidth: '1px',
              marker: {
                backgroundColor: 'var(--primary-tint)',
              },
            },
          ],
          noData: {
            text: 'No Selection',
            alpha: 0.6,
            backgroundColor: '#20b2db',
            bold: true,
            fontSize: '10px',
            textAlpha: 0.9,
          },
        };


      }))
  }



  bottom: any = []
  items: any = [];
  boxes: any = [];
  lastMonthDaysCouponScanCount: any = [];
  scanningInDaysChart: any;
  getThirtyDaysScanningItemBox() {
    this.bottom = [];
    this.items = [];
    this.boxes = [];
    this.serve.get_rqst2({}, "LoyaltyDashboard/dashboard_graph").subscribe((result => {
      this.lastMonthDaysCouponScanCount = result['last_month_days_coupon_scan_count']



      for (let i = 0; i < this.lastMonthDaysCouponScanCount.scanned_date.length; i++) {
        this.bottom.push(this.lastMonthDaysCouponScanCount.scanned_date[i].lable)
      }

      for (let i = 0; i < this.lastMonthDaysCouponScanCount.item_wise_coupon_count.length; i++) {
        this.items.push(this.lastMonthDaysCouponScanCount.item_wise_coupon_count[i].value)
      }

      for (let i = 0; i < this.lastMonthDaysCouponScanCount.master_wise_coupon_count.length; i++) {
        this.boxes.push(this.lastMonthDaysCouponScanCount.master_wise_coupon_count[i].value)
      }


      this.scanningInDaysChart = {
        type: "line",
        scaleX: {
          labels: this.bottom,
          "step": "86400000",
          "transform": {
            "type": "date",
            "all": "%d<br/>day"
          },
          "item": {
            "font-size": 9
          },
        },
        "tooltip": {
          "visible": false
        },
        plot: {
          aspect: "spline",
          "tooltip-text": "%t views: %v<br>%k",
          "shadow": 0,
          "line-width": "2px",
          "marker": {
            "type": "circle",
            "size": 3
          }
        },
        plotarea: {
          backgroundColor: 'transparent',
          marginTop: '20px',
        },
        "crosshair-x": {
          "line-color": "#efefef",
          "plot-label": {
            "border-radius": "5px",
            "border-width": "1px",
            "border-color": "#f6f7f8",
            "padding": "10px",
            "font-weight": "bold"
          },
          "scale-label": {
            "font-color": "#000",
            "background-color": "#f6f7f8",
            "border-radius": "5px"
          }
        },
        series: [{
          values: this.items,
          monotone: true,
          text: "Items",
          lineColor: 'var(--primary-tint)',
          "marker": {
            "background-color": "var(--primary-tint)",
          },

        },
        {
          values: this.boxes,
          monotone: true,
          text: "Boxes",
          lineColor: 'var(--text)',
          "marker": {
            "background-color": "var(--text)",
          },
          "highlight-state": {
            "line-width": 3
          },
        },

        ]
      }

    }))

  }


  lastCouponCount: any = [];
  lastYearCouponScanCount: any = [];
  couponStatusBarChart: any;
  lables: any = [];
  scannedCoupon: any = [];
  generatedCoupon: any = [];
  getCouponStatus() {
    this.lables = [];
    this.generatedCoupon = [];
    this.scannedCoupon = [];
    this.serve.get_rqst2({}, "LoyaltyDashboard/dashboard_graph_coupon_status").subscribe((result => {
      this.lastYearCouponScanCount = result['last_year_coupon_scan_count'];
      this.lastCouponCount = result['last_year_coupon_count']['coupon_count'];

      for (let i = 0; i < this.lastYearCouponScanCount.scanned_date.length; i++) {
        this.lables.push(this.lastYearCouponScanCount.scanned_date[i].lable)
      }

      for (let i = 0; i < this.lastCouponCount.length; i++) {
        this.generatedCoupon.push(this.lastCouponCount[i].value)
      }

      for (let i = 0; i < this.lastYearCouponScanCount.coupon_count.length; i++) {
        this.scannedCoupon.push(this.lastYearCouponScanCount.coupon_count[i].value)
      }

      this.couponStatusBarChart = {
        type: "bar",
        scaleX: {
          labels: this.lables,
        },
        plot: {
          valueBox: {
            text: '%v',
            short: true,
            placement: "top-out",
            'font-color': "black",
            'font-weight': 'normal',
            'font-size': '10px',
            thousandsSeparator: ',',
          },
          animation: {
            effect: 11,
            speed: 3000,
          }
        },
        plotarea: {
          backgroundColor: 'transparent',
          marginTop: '60px',
          marginRight: '15px',
          marginLeft: '80px'
        },
        series: [
          {
            text: 'Invoice',
            values: this.generatedCoupon,
            backgroundColor: '#0071bd'

          },
          {
            text: 'Collection',
            values: this.scannedCoupon,
            backgroundColor: '#6ec44d'
          }
        ]
      };
    }))
  }

  topInfluencer: any = [];
  getTopInfluencer() {
    this.serve.get_rqst2({}, "LoyaltyDashboard/top_ten_influencer_list").subscribe((result => {
      this.topInfluencer = result['top_ten_influencer']

    }))

  }

  regionScanningBarChart: any;
  RegionWise: any = [];
  RegionScanningWise: any = [];
  getRegionInfluencer() {

    this.serve.get_rqst2({}, "LoyaltyDashboard/regionWiseData").subscribe((result => {
      this.RegionWise = result['region_wise_percentage']['region_wise_influencer_customer'];
      this.RegionScanningWise = result['region_wise_percentage']['region_wise_scan_count'];

      let East = this.RegionWise[0]['region'];
      let West = this.RegionWise[1]['region'];
      let North = this.RegionWise[2]['region'];
      let South = this.RegionWise[3]['region'];

      let Eastpercent = parseInt(this.RegionWise[0]['region_wise_percentage']);
      let Westpercent = parseInt(this.RegionWise[1]['region_wise_percentage']);
      let Northpercent = parseInt(this.RegionWise[2]['region_wise_percentage']);
      let Southpercent = parseInt(this.RegionWise[3]['region_wise_percentage']);

      let EastScanpercent = parseInt(this.RegionScanningWise[0]['region_wise_scan']);
      let WestScanpercent = parseInt(this.RegionScanningWise[1]['region_wise_scan']);
      let NorthScanpercent = parseInt(this.RegionScanningWise[2]['region_wise_scan']);
      let SouthScanpercent = parseInt(this.RegionScanningWise[3]['region_wise_scan']);


      this.regionScanningBarChart = {
        type: "hbar",
        scaleX: {
          labels: [East, West, North, South],
        },
        scaleY: {
          visible: false
        },
        plot: {
          valueBox: {
            text: '%v%',
            placement: "top-in",
            'font-color': "#fff",
            'font-weight': '400',
            thousandsSeparator: ',',
          },
          animation: {
            effect: 11,
            speed: 3000,
          }
        },
        plotarea: {
          backgroundColor: 'transparent',
          marginTop: '0',
          marginRight: '15px',
          marginLeft: '80px'
        },
        series: [
          {
            values: [Eastpercent, Westpercent, Northpercent, Southpercent],
            backgroundColor: 'var(--primary-tint)'
          },
          {
            values: [EastScanpercent, WestScanpercent, NorthScanpercent, SouthScanpercent],
            backgroundColor: 'var(--text)'
          }
        ]
      };


    }))

  }


  scanningAgeChart: any;
  ScanAgeing: any = {};
  NotScannedAgeing: any = {};
  getScanAgeing() {
    this.serve.get_rqst2({}, "LoyaltyDashboard/coupon_scan_ageing").subscribe((result => {
      this.ScanAgeing = result['coupon_scan_ageing'];
      let lastSevenDaysCount = this.ScanAgeing.last_seven_days_count;
      let lastOneMonthCount = this.ScanAgeing.last_one_month_count;
      let lastSixMonthCount = this.ScanAgeing.last_six_month_count;
      let lastOneYearCount = this.ScanAgeing.last_one_year_count;

      this.serve.get_rqst2({}, "LoyaltyDashboard/coupon_not_scan_ageing").subscribe((result => {
        this.NotScannedAgeing = result['coupon_not_scan_ageing'];
        let NotScannedCount = this.NotScannedAgeing.not_scanned_count;

        this.scanningAgeChart = {
          type: 'bar',
          plot: {
            barWidth: '25px',
            tooltip: {
              borderRadius: '3px',
              borderWidth: '1px',
              fontSize: '14px',
              shadow: true,
            },
            animation: {
              effect: 4,
              method: 0,
              speed: 1600,
            },
            valueBox:
            {
              type: 'all',
              placement: "top-out",
              short: true,
              text: '%v%',
              // text: `${parseInt(data[0]/(data[0]+data[1])*100)}%`,
              angle: 0,
              fontSize: '10px',
              fontWeight: '100',
              "font-color": "black",

            },
          },
          scaleX: {
            "transform": {
              "type": "text",

            },
            "item": {
              "font-size": 9
            },
            wrapText: true,
            labels: ['0-7<br/>Days', 'Last 30<br/>Days', 'Last 06<br/>Months', 'Last<br/>01 Year', 'Not<br/>Scanning'],
          },
          scaleY: {
            visible: false
          },
          series: [
            {
              values: [lastSevenDaysCount, lastOneMonthCount, lastSixMonthCount, lastOneYearCount, NotScannedCount],
              styles: [
                { 'background-color': 'var(--success)' },
                { 'background-color': 'var(--primary-tint)' },
                { 'background-color': 'var(--primary-tint)' },
                { 'background-color': 'var(--primary-tint)' },
                { 'background-color': '#ea4335' },
              ]
            },

          ],

        };


      }))










    }))

  }


  TopProductCategory: any = [];
  getTopProductCategory() {
    this.serve.get_rqst2({}, "LoyaltyDashboard/top_product_category").subscribe((result => {
      this.TopProductCategory = result['top_product']['total_scanned_coupon_count']

    }))

  }

  BonusSchemeScanned: any = [];
  getTopBonusSchemeScanned() {
    this.serve.get_rqst2({}, "LoyaltyDashboard/top_product_scheme").subscribe((result => {
      this.BonusSchemeScanned = result['top_product_scheme']['total_scanned_coupon_count']

    }))

  }

  ScanMeter: any = []
  scanningMeter: any;
  getScanningMeter() {
    this.serve.get_rqst2({}, "LoyaltyDashboard/last_month_scanning_meter").subscribe((result => {
      this.ScanMeter = result['scanning_meter']
      this.scanningMeter = {
        type: 'gauge',
        globals: {
          fontSize: '18px',
        },
        plot: {
          tooltip: {
            borderRadius: '5px',
            fontSize: '10px'
          },
          valueBox: {

            text: '%v',
            fontSize: '14px',
            placement: 'center',
            rules: [
              {
                text: '%v<br>Days',
                rule: '%v <= 30',
              },
            ],
          },
          size: '100%',
          animation: {
            effect: 11,
            speed: 3000,
          }
        },
        plotarea: {
          backgroundColor: 'transparent',
          marginTop: '40px',
        },
        scaleR: {

          aperture: 180,
          center: {
            visible: false,
          },
          item: {
            offsetR: 0,

          },
          labels: ['0', '', '', '', this.totalDays],
          maxValue: 31,
          minValue: 1,
          ring: {
            rules: [
              {
                backgroundColor: '#b5a1c8',
                rule: '%v <= 8',
              },
              {
                backgroundColor: '#654779',
                rule: '%v >= 8 && %v <= 16',
              },
              {
                backgroundColor: '#433051',
                rule: '%v >= 18 && %v <= 31',
              },
            ],
            size: '50px'
          },
          step: 10,
          tick: {
            visible: false,
          },

        },

        refresh: {
          type: 'feed',
          url: 'feed()',
          interval: 1500,
          resetTimeout: 1000,
          transport: 'js',
        },
        series: [
          {
            values: [this.dayInMonth],
            backgroundColor: 'black',
            indicator: [0.1, 4, 5, 5, 0.3],

          },
        ],

      };

    }))

  }


  ReddemMeter: any = []
  pointRedeemMeter: any;
  getPointReddemMeter() {
    this.serve.get_rqst2({}, "LoyaltyDashboard/last_month_redeem_meter").subscribe((result => {
      this.ReddemMeter = result['redeem_meter']

      this.pointRedeemMeter = {
        type: 'gauge',
        globals: {
          fontSize: '18px',
        },
        plot: {
          tooltip: {
            borderRadius: '5px',
            fontSize: '10px'
          },
          valueBox: {
            text: '%v',
            fontSize: '14px',
            placement: 'center',
            rules: [
              {
                text: '%v<br>Days',
                rule: '%v <= 30',
              },
            ],
          },
          size: '100%',
        },
        plotarea: {
          backgroundColor: 'transparent',
          marginTop: '40px',
          fontSize: '10px'
        },
        scaleR: {
          aperture: 180,
          center: {
            visible: false,
          },
          item: {
            offsetR: 0,

          },
          labels: ['0', '', '', '', this.totalDays],
          maxValue: 31,
          minValue: 1,
          ring: {
            rules: [
              {
                backgroundColor: '#b5a1c8',
                rule: '%v <= 8',
              },
              {
                backgroundColor: '#654779',
                rule: '%v >= 8 && %v <= 16',
              },
              {
                backgroundColor: '#433051',
                rule: '%v >= 18 && %v <= 31',
              },
            ],
            size: '50px'
          },
          step: 7.75,
          tick: {
            visible: false,
          },
        },
        refresh: {
          type: 'feed',
          url: 'feed()',
          interval: 1500,
          resetTimeout: 1000,
          transport: 'js',
        },
        series: [
          {
            values: [this.dayInMonth],
            animation: {
              delay: 1200,
              effect: 2,
              method: 3,
              speed: 3000,
            },
            backgroundColor: 'black',
            indicator: [0.1, 4, 5, 5, 0.3],
          },
        ],

      };


    }))

  }




  InflunecerSource: any = [];
  influencerConversionPieChart: any
  getTopInflucencerSource() {
    this.serve.get_rqst2({}, "LoyaltyDashboard/top_influencer_source").subscribe((result => {
      this.InflunecerSource = result['influencer_source']
      let selfRegisteredInfluencerCount = parseInt(this.InflunecerSource.self_registered_influencer_count)
      let salesUserInfluencerCount = parseInt(this.InflunecerSource.sales_user_influencer_count)
      let referredInfluencerCount = parseInt(this.InflunecerSource.referred_influencer_count)

      this.influencerConversionPieChart = {
        type: 'ring',
        backgroundColor: '#fff',

        plot: {
          tooltip: {
            backgroundColor: 'black',
            borderWidth: '0px',
            fontSize: '10px',
            sticky: true,
            thousandsSeparator: ',',
            text: '%t<br/>%npv%'
          },
          valueBox:
          {
            type: 'all',
            text: '%npv%',
            placement: 'out',
            fontSize: '10px'
          },

          animation: {
            effect: 2,
            sequence: 3,
            speed: 1000
          },
          backgroundColor: '#FBFCFE',
          borderWidth: '0px',

          slice: 60,
        },
        plotarea: {
          margin: '0px',
          backgroundColor: 'transparent',
          borderRadius: '10px',
          borderWidth: '0px',
        },
        series: [
          {
            text: 'Self Registration',
            values: [selfRegisteredInfluencerCount],
            backgroundColor: 'var(--success)',
            lineColor: 'var(--success)',
            lineWidth: '1px',
            marker: {
              backgroundColor: 'var(--success)',
            },
          },

          {
            text: 'Register By Sales Executive',
            values: [salesUserInfluencerCount],
            backgroundColor: 'var(--warning)',
            lineColor: 'var(--warning)',
            lineWidth: '1px',
            marker: {
              backgroundColor: 'var(--warning)',
            },
          },
          {
            text: 'Referral By Influencer',
            values: [referredInfluencerCount],
            backgroundColor: 'var(--danger)',
            lineColor: 'var(--danger)',
            lineWidth: '1px',
            marker: {
              backgroundColor: 'var(--danger)',
            },
          },
        ],
        noData: {
          text: 'No Selection',
          alpha: 0.6,
          backgroundColor: '#20b2db',
          bold: true,
          fontSize: '10px',
          textAlpha: 0.9,
        },
      };

    }))

  }




  /////////////////////////////////////////CHARTS/////////////////////////////////////
  segmentPieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {
        backgroundColor: 'none',
        borderWidth: '0px',
        fontSize: '10px',

        sticky: true,
        thousandsSeparator: ',',

      },
      valueBox:
      {
        type: 'all',
        text: '%t<br>%npv%',
        placement: 'out',
        fontSize: '10px'
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',
      slice: 30,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },
    series: [
      {
        text: 'Segment 1',
        values: [16541],
        backgroundColor: '#00889f',
        lineColor: '#00889f',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#00889f',
        },
      },
      {
        text: 'Segment 2',
        values: [36711],
        backgroundColor: '#3691d6',
        lineColor: '#3691d6',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#3691d6',
        },
      },
      {
        text: 'Segment 3',
        values: [50011],
        backgroundColor: '#b5a1c8',
        lineColor: '#b5a1c8',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#b5a1c8',
        },
      },
      {
        text: 'Segment 4',
        values: [20711],
        backgroundColor: '#ffbd00',
        lineColor: '#ffbd00',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ffbd00',
        },
      },
      {
        text: 'Segment 5',
        values: [16711],
        backgroundColor: '#7f7f7f',
        lineColor: '#7f7f7f',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#7f7f7f',
        },
      },
      {
        text: 'Segment 6',
        values: [26711],
        backgroundColor: '#9B26AF',
        lineColor: '#9B26AF',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#9B26AF',
        },
      },
      {
        text: 'Segment 7',
        values: [10711],
        backgroundColor: '#e3c889',
        lineColor: '#e3c889',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#e3c889',
        },
      },

    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };

  leadPieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {
        backgroundColor: 'none',
        borderWidth: '0px',
        fontSize: '10px',

        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox:
      {
        type: 'all',
        text: '%t<br>%npv%',
        placement: 'out',
        fontSize: '10px'
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',
      slice: 40,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },
    series: [
      {
        text: 'Contractor',
        values: [16541],
        backgroundColor: '#26a0fc',
        lineColor: '#26a0fc',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#26a0fc',
        },
      },
      {
        text: 'Architect',
        values: [36711],
        backgroundColor: '#68d4cd',
        lineColor: '#68d4cd',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#68d4cd',
        },
      },
      {
        text: 'Site',
        values: [50011],
        backgroundColor: '#ffc000',
        lineColor: '#ffc000',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ffc000',
        },
      },

    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };
  totalFocusDealerPieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {

        backgroundColor: '#000',
        borderWidth: '0px',
        fontSize: '10px',
        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox:
      {
        type: 'all',
        text: '%npv%',
        placement: 'in',
        fontSize: '8px'
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',
      slice: 40,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },

    series: [


      {
        text: 'present',
        values: [60],
        backgroundColor: '#00a54d',
        lineColor: '#009fb5',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#009fb5',
        },
      },
      {
        text: 'absent',
        values: [20],
        backgroundColor: '#ff4b4a',
        lineColor: '#ff4b4a',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ff4b4a',
        },
      }

    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };
   subDepartmentDataPieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {

        backgroundColor: '#000',
        borderWidth: '0px',
        fontSize: '10px',
        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox:
      {
        type: 'all',
        text: '%npv%',
        placement: 'in',
        fontSize: '8px'
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',
      slice: 40,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },

    series: [


      {
        text: 'present',
        values: [60],
        backgroundColor: '#00a54d',
        lineColor: '#009fb5',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#009fb5',
        },
      },
      {
        text: 'absent',
        values: [20],
        backgroundColor: '#ff4b4a',
        lineColor: '#ff4b4a',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ff4b4a',
        },
      }

    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };
  totalAttendancePieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {
        backgroundColor: '#000',
        borderWidth: '0px',
        fontSize: '10px',
        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox: {
        type: 'all',
        text: '%npv%',
        placement: 'in',
        fontSize: '8px',
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000,
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',
      slice: 40,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },

    series: [
      {
        text: 'leave',
        values: [20],
        backgroundColor: '#ffc300',
        lineColor: '#ffc300',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ffc300',
        },
      },
      {
        text: 'holiday',
        values: [20],
        backgroundColor: '#00b7ff',
        lineColor: '#00b7ff',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#00b7ff',
        },
      },
      {
        text: 'present',
        values: [60],
        backgroundColor: '#00a54d',
        lineColor: '#009fb5',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#009fb5',
        },
      },
      {
        text: 'absent',
        values: [20],
        backgroundColor: '#ff4b4a',
        lineColor: '#ff4b4a',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ff4b4a',
        },
      },
    ],

    // Adding labels to show total value and "Total" text
    labels: [
      {
        text: '120', // Total value
        fontSize: '16px',
        fontColor: '#000',
        fontWeight: 'bold',
        x: '50%',
        y: '45%', // Slightly above center
        anchor: 'c',
      },
      {
        text: 'Total', // Label under the total number
        fontSize: '12px',
        fontColor: '#000',
        fontWeight: 'normal',
        x: '50%',
        y: '55%', // Slightly below center
        anchor: 'c',
      },
    ],

    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };


  totalEnquiryPieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {

        backgroundColor: '#000',
        borderWidth: '0px',
        fontSize: '10px',
        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox:
      {
        type: 'all',
        text: '%npv%',
        placement: 'in',
        fontSize: '8px'
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',
      slice: 40,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },

    series: [
      {
        text: 'Review Pending',
        values: [20],
        backgroundColor: '#ffc300',
        lineColor: '#ffc300',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ffc300',
        },
      },
      {
        text: 'Qualified',
        values: [60],
        backgroundColor: '#00a54d',
        lineColor: '#009fb5',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#009fb5',
        },
      },
      {
        text: 'Disqualified',
        values: [20],
        backgroundColor: '#ff4b4a',
        lineColor: '#ff4b4a',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ff4b4a',
        },
      }

    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };


  CustomerBarChart = {
    type: 'bar',
    plot: {
      'background-color': "#FFD700", // Updated background color to a gold-yellow tone
      alpha: 0.8,
      'hover-state': {
        backgroundColor: '#FFA500', // Hover color to orange-yellow
        alpha: 0.9
      },
      'value-box': {
        text: '%v',
        'font-color': '#6d541e', // Dark brownish color to match your yellow theme
        'font-size': 12,
        placement: 'top-out'
      }
    },
    scaleX: {
      labels: this.labels,
      item: {
        angle: -48,
        'font-color': '#6d541e', // Font color for axis labels
        'font-weight': 'bold',
        'font-size': 12
      },
      'tick': {
        'line-color': '#FFD700' // Color of the ticks
      }
    },
    scaleY: {
      'line-color': '#FFD700', // Scale line color
      'tick': {
        'line-color': '#FFD700' // Y-axis tick color
      },
      guide: {
        'line-color': '#F2D600' // Guide line color
      },
      'item': {
        'font-color': '#6d541e' // Font color for Y-axis values
      }
    },
    series: [
      {
        values: this.Count_values,
        'background-color': "#F2D600", // Bar color matching the yellow theme
        'hover-state': {
          backgroundColor: "#FFA500" // Bar hover state color
        }
      }
    ]
  };

  qualifiedEnquiryPieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {
        backgroundColor: 'black',
        borderWidth: '0px',
        fontSize: '10px',

        sticky: true,

      },
      valueBox:
      {
        type: 'all',
        text: '%npv%',
        placement: 'in',
        fontSize: '8px'
      },

      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',
      slice: 40,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },

    series: [
      {
        text: 'Success',
        values: [200],
        backgroundColor: '#46a345',
        lineColor: '#46a345',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#46a345',
        },
      },
      {
        text: 'Rejected',
        values: [200],
        backgroundColor: '#ff4b4a',
        lineColor: '#ff4b4a',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ff4b4a',
        },
      },
      {
        text: 'In Process',
        values: [200],
        backgroundColor: '#ffc300',
        lineColor: '#ffc300',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ffc300',
        },
      },
    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };

  sourceEnquiryPieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {

        backgroundColor: 'none',
        borderWidth: '0px',
        fontSize: '10px',
        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox:
      {
        type: 'all',
        text: '%v%',
        placement: 'in',
        fontSize: '8px'
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',

      slice: 40,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },
    // values: [2, 40, 14, 50, 10, 35, 45, 20, 45, 18, 48, 15, 38, 35,55,56,57,58],
    series: [
      {
        text: 'Facebook',
        values: [2],
        backgroundColor: '#95ce50',
        lineColor: '#95ce50',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#95ce50',
        },
      },
      {
        text: 'Website',
        values: [40],
        backgroundColor: '#ffb300',
        lineColor: '#ffb300',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ffb300',
        },
      },
      {
        text: 'Google',
        values: [14],
        backgroundColor: '#ff6f00',
        lineColor: '#ff6f00',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ff6f00',
        },
      },
      {
        text: 'Inbound',
        values: [50],
        backgroundColor: '#00897b',
        lineColor: '#00897b',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#00897b',
        },
      },
      {
        text: 'IndiaMart',
        values: [10],
        backgroundColor: '#43a047',
        lineColor: '#43a047',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#43a047',
        },
      },

      {
        text: 'Toll-Free',
        values: [35],
        backgroundColor: '#2e7d32',
        lineColor: '#2e7d32',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#2e7d32',
        },
      },
      {
        text: 'Instagram',
        values: [20],
        backgroundColor: '#f70474',
        lineColor: '#f70474',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#f70474',
        },
      },
      {
        text: 'Mail',
        values: [45],
        backgroundColor: '#0077b5',
        lineColor: '#0077b5',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#0077b5',
        },
      },
      {
        text: 'Reference',
        values: [18],
        backgroundColor: '#d778b3',
        lineColor: '#d778b3',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#d778b3',
        },
      },
      {
        text: 'Whatsapp',
        values: [48],
        backgroundColor: '#1bd741',
        lineColor: '#1bd741',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#1bd741',
        },
      },
      {
        text: 'Others',
        values: [15],
        backgroundColor: '#ea4335',
        lineColor: '#ea4335',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ea4335',
        },
      },
      {
        text: 'IndiaMart',
        values: [38],
        backgroundColor: '#1c124f',
        lineColor: '#1c124f',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#1c124f',
        },
      },
     {
        text: 'Call',
        values: [55],
        backgroundColor: '#72acae',
        lineColor: '#72acae',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#72acae',
        },
      },
      {
        text: 'Walk',
        values: [56],
        backgroundColor: '#1dc0d9',
        lineColor: '#1dc0d9',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#1dc0d9',
        },
      },
      {
        text: 'Linked-in',
        values: [57],
        backgroundColor: '#0077b5',
        lineColor: '#0077b5',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#0077b5',
        },
      },
      {
        text: 'JustDial',
        values: [57],
        backgroundColor: '#b9cf0e',
        lineColor: '#b9cf0e',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#b9cf0e',
        },
      },
      {
        text: 'SMS',
        values: [58],
        backgroundColor: '#e10ec9',
        lineColor: '#e10ec9',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#e10ec9',
        },
      },
    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };




  invoiceCollectionBarChart: any = {
    type: "bar",
    scaleX: {
      labels: ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
    },
    plot: {
      valueBox: {
        text: '%v',
        short: true,
        placement: "top-out",
        'font-color': "black",
        'font-weight': 'normal',
        'font-size': '10px',
        thousandsSeparator: ',',
      },
      animation: {
        effect: 11,
        speed: 3000,
      }
    },
    plotarea: {
      backgroundColor: 'transparent',
      marginTop: '60px',
      marginRight: '15px',
      marginLeft: '80px'
    },
    series: [
      {
        text: 'Invoice',
        values: this.invoiceValue,
        backgroundColor: '#0071bd'
      },
      {
        text: 'Collection',
        values: this.collectionValue,
        backgroundColor: '#6ec44d'
      }
    ]
  };

  accountBarChart: ZingchartAngular.graphset = {
    type: "bar",
    scaleX: {
      labels: ['0 or less', '1 ~ 30', '31 ~ 60', '61 ~ 90', 'Over 90'],
    },
    plot: {
      valueBox: {
        text: '%v',
        placement: "top-in",
        'font-color': "black",
        thousandsSeparator: ',',
      },
      animation: {
        effect: 11,
        speed: 3000,
      }
    },
    plotarea: {
      backgroundColor: 'transparent',
      marginTop: '0',
      marginRight: '15px',
      marginLeft: '80px'
    },
    series: [
      {
        values: [2012, 4220, 2445, 5000, 2500],
        backgroundColor: '#00ccfd'
      },
      {
        values: [5233, 3000, 2123, 3875, 3000],
        backgroundColor: '#bac0c3'
      }
    ]
  };



  enquiryScore: any = {
    type: 'gauge',
    globals: {
      fontSize: '18px',
    },
    plot: {
      tooltip: {
        borderRadius: '5px',
        fontSize: '10px'
      },
      valueBox: {
        text: '%v%',
        fontSize: '18px',
        placement: 'center',
        rules: [
          {
            text: '%v',
            rule: '%v <= 30',
          },
        ],
      },
      size: '100%',
      animation: {
        effect: 11,
        speed: 3000,
      }
    },
    plotarea: {
      backgroundColor: 'transparent',
      marginTop: '40px',
    },
    scaleR: {
      aperture: 240,
      center: {
        visible: false,
      },
      item: {
        offsetR: 0,

      },
      labels: ['0', '', '', '', '100'],
      maxValue: 100,
      minValue: 0,
      ring: {
        rules: [
          {
            backgroundColor: '#ea4335',
            rule: '%v <= 25',
          },
          {
            backgroundColor: '#ffc300',
            rule: '%v >= 25 && %v <= 50',
          },
          {
            backgroundColor: '#2e7d32',
            rule: '%v > 50 && %v <= 100',
          },
        ],
        size: '20px',
      },
      step: 25,
      tick: {
        visible: false,
      },
    },
    refresh: {
      type: 'feed',
      url: 'feed()',
      interval: 1500,
      resetTimeout: 1000,
      transport: 'js',
    },
    series: [
      {
        values: [74],
        animation: {
          delay: 1200,
          effect: 2,
          method: 3,
          speed: 3000,
        },
        backgroundColor: 'black',
        indicator: [0.1, 4, 5, 5, 0.3],
      },
    ],

  };

  accuracyLead: any = {
    type: 'gauge',
    globals: {
      fontSize: '18px',
    },
    plot: {
      tooltip: {
        borderRadius: '5px',
        fontSize: '10px'
      },
      valueBox: {
        text: '%v%',
        fontSize: '18px',
        placement: 'center',
        rules: [
          {
            text: '%v',
            rule: '%v <= 30',
          },
        ],
      },
      size: '100%',
      animation: {
        effect: 11,
        speed: 3000,
      }
    },
    plotarea: {
      backgroundColor: 'transparent',
      marginTop: '40px',
    },
    scaleR: {
      aperture: 240,
      center: {
        visible: false,
      },
      item: {
        offsetR: 0,

      },
      labels: ['0', '', '', '', '100'],
      maxValue: 100,
      minValue: 0,
      ring: {
        rules: [
          {
            backgroundColor: '#ea4335',
            rule: '%v <= 25',
          },
          {
            backgroundColor: '#ffc300',
            rule: '%v >= 25 && %v <= 50',
          },
          {
            backgroundColor: '#2e7d32',
            rule: '%v > 50 && %v <= 100',
          },
        ],
        size: '20px',
      },
      step: 25,
      tick: {
        visible: false,
      },
    },
    refresh: {
      type: 'feed',
      url: 'feed()',
      interval: 1500,
      resetTimeout: 1000,
      transport: 'js',
    },
    series: [
      {
        values: [74],
        animation: {
          delay: 1200,
          effect: 2,
          method: 3,
          speed: 3000,
        },
        backgroundColor: 'black',
        indicator: [0.1, 4, 5, 5, 0.3],
      },
    ],

  };

  disqualifiedMeter: any = {
    type: 'ring',
    backgroundColor: '#fff',
    plot: {
      tooltip: {

        backgroundColor: 'none',
        borderWidth: '0px',
        fontSize: '0px',
        visible: false,
        sticky: true,
      },
      valueBox:
      {
        type: 'min',
        text: '%v%',
        // text: `${parseInt(data[0]/(data[0]+data[1])*100)}%`,
        fontColor: '#718096',
        fontSize: '20px',
        placement: 'center',
        visible: true,
        offsetY: '25px',
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',

      slice: 50,
    },

    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },
    scaleR: {
      refAngle: 130,
      aperture: 280,
    },
    series: [
      {
        text: 'Disqualified',
        values: [50],
        backgroundColor: '#ff4b4a',
        lineColor: '#ff4b4a',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ff4b4a',
        },
      },
      {
        text: 'total',
        values: [50],
        backgroundColor: '#009fb5',
        lineColor: '#009fb5',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#009fb5',
        },
      },

    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };

  gaugeConfig: any = {
    type: 'gauge',
    globals: {
      fontSize: '18px',
    },
    plot: {
      tooltip: {
        borderRadius: '5px',
        fontSize: '10px'
      },
      valueBox: {
        text: '%v',
        fontSize: '14px',
        placement: 'center',
        rules: [
          {
            text: '%v<br>Days',
            rule: '%v <= 30',
          },
        ],
      },
      size: '100%',
    },
    plotarea: {
      backgroundColor: 'transparent',
      marginTop: '40px',
      fontSize: '10px'
    },
    scaleR: {
      "values": `0:${this.lastDay}:10`,
      aperture: 180,
      center: {
        visible: false,
      },
      item: {
        offsetR: 0,

      },
      labels: ['1', '', '', this.lastDay],
      maxValue: this.lastDay,
      minValue: 1,
      ring: {
        rules: [
          {
            backgroundColor: '#b5a1c8',
            rule: '%v <= 10',
          },
          {
            backgroundColor: '#654779',
            rule: '%v >= 10 && %v <= 20',
          },
          {
            backgroundColor: '#433051',
            rule: '%v >= 20 && %v <= 30',
          },
        ],
        size: '50px'
      },
      step: 10,
      tick: {
        visible: false,
      },
    },
    refresh: {
      type: 'feed',
      url: 'feed()',
      interval: 1500,
      resetTimeout: 1000,
      transport: 'js',
    },
    series: [
      {
        values: [this.currentDay],
        animation: {
          delay: 1200,
          effect: 2,
          method: 3,
          speed: 3000,
        },
        backgroundColor: 'black',
        indicator: [0.1, 4, 5, 5, 0.3],
      },
    ],

  };





  sourceleadConfig: any = {
    type: 'bar',
    plot: {
      barWidth: '25px',
      tooltip: {
        borderRadius: '3px',
        borderWidth: '1px',
        fontSize: '14px',
        shadow: true,
      },
      animation: {
        effect: 4,
        method: 0,
        speed: 1600,
      },
      valueBox:
      {
        type: 'all',
        placement: "top-in",
        text: '%v%',
        angle: 0,
        fontSize: '10px',
        fontWeight: '100',
        "font-color": "white",

      },
    },
    scaleX: {
      labels: ['Facebook', 'Website', 'Google Ads', 'Inbound/IVR', 'IndiaMart', 'Mail', 'Others', 'Reference', 'Toll Free', 'Whatsapp', 'Instagram','Call','JustDial','Linked-in','SMS','Walk'],

      values: [this.sourceWiseConversion.Facebook, this.sourceWiseConversion.Website, this.sourceWiseConversion['Google ds'], this.sourceWiseConversion['Inbound/IVR'], this.sourceWiseConversion.IndiaMart, this.sourceWiseConversion['Mail'],this.sourceWiseConversion.Others, this.sourceWiseConversion.Reference,this.sourceWiseConversion['Toll Free'],this.sourceWiseConversion.Whatsapp, this.sourceWiseConversion.Instagram,this.sourceWiseEnquiry.Call,this.sourceWiseEnquiry.Walk,this.sourceWiseEnquiry['Linked-in'],this.sourceWiseEnquiry['SMS'],this.sourceWiseEnquiry['JustDial ']],

    },
    series: [
      {
        values: [2, 40, 14, 50, 10, 35, 45, 20, 40, 14, 50, 15, 35, 35],
        styles: [
          { backgroundColor: '#95ce50' },
          { backgroundColor: '#ffb300' },
          { backgroundColor: '#ff6f00' },
          { backgroundColor: '#00897b' },
          { backgroundColor: '#43a047' },
          { backgroundColor: '#2e7d32' },
          { backgroundColor: '#989c25' },
          { backgroundColor: '#f70474' },
          { backgroundColor: '#0077b5' },
          { backgroundColor: '#d778b3' },
          { backgroundColor: '#1bd741' },
          { backgroundColor: '#ea4335' },
          { backgroundColor: '#1c124f' },
          { backgroundColor: '#fc6904' },
          { backgroundColor: '#72acae' },
          { backgroundColor: '#1dc0d9' },
          { backgroundColor: '#0077b5' },
          { backgroundColor: '#e10ec9' },
        ],
      },

    ],

  };




  duBalanceAgeChart: any = {
    type: 'bar',
    plot: {
      barWidth: '25px',
      tooltip: {
        borderRadius: '3px',
        borderWidth: '1px',
        fontSize: '14px',
        shadow: true,
      },
      animation: {
        effect: 4,
        method: 0,
        speed: 1600,
      },
      valueBox:
      {
        type: 'all',
        placement: "top-out",
        short: true,
        text: '%v',
        angle: 0,
        fontSize: '10px',
        fontWeight: '100',
        "font-color": "black",

      },
    },
    scaleX: {
      "transform": {
        "type": "text",

      },
      "item": {
        "font-size": 9
      },
      wrapText: true,
      labels: ['Within<br/>Due Days', 'Over Due<br/>0-30<br/>Days', 'Over Due<br/>31-60<br/>Days', 'Over Due<br/>61-90<br/>Days', 'Due Over<br/>90 Days'],
    },
    scaleY: {
      visible: false
    },
    series: [
      {
        values: [40000, 10000, 14000, 50000, 15000],
        styles: [
          { 'background-color': '#00ff00' },
          { 'background-color': '#0073bd' },
          { 'background-color': '#0073bd' },
          { 'background-color': '#0073bd' },
          { 'background-color': '#ea4335' },
        ]
      },

    ],

  };

  categoryleadConfig: any = {
    type: 'bar',
    title: {
      text: '',
    },
    plot: {
      tooltip: {
        borderRadius: '3px',
        borderWidth: '1px',
        fontSize: '14px',
        shadow: true,
      },
      animation: {
        effect: 4,
        method: 0,
        speed: 1600,
      },
      valueBox:
      {
        type: 'all',
        placement: "top-in",
        text: '%v%',
        angle: 0,
        fontSize: '10px',
        fontWeight: '100',
        "font-color": "white"
      },
    },
    scaleX: {
      labels: ['Contractor', 'Architect', 'Site'],
    },
    series: [
      {
        values: [20, 13, 14],
        dataDragging: true,
        goal: {
          borderWidth: '1px',
          height: 0,
          borderColor: '#000'
        },
        goals: [25, 30, 30],
        styles: [
          { backgroundColor: '#989c25' },
          { backgroundColor: '#f70474' },
          { backgroundColor: '#0077b5' },
        ],
      },
    ],
  };



  invoicePieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {

        backgroundColor: 'none',
        borderWidth: '0px',
        fontSize: '10px',
        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox:
      {
        type: 'all',
        text: '%t<br>%npv%',
        placement: 'out',
        fontSize: '10px'
      },

      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',

      slice: 40,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },
    series: [
      {
        text: 'Invoice 1',
        values: [16541],
        backgroundColor: '#00889f',
        lineColor: '#00889f',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#00889f',
        },
      },
      {
        text: 'Invoice 2',
        values: [36711],
        backgroundColor: '#3691d6',
        lineColor: '#3691d6',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#3691d6',
        },
      },
      {
        text: 'Invoice 3',
        values: [50011],
        backgroundColor: '#b5a1c8',
        lineColor: '#b5a1c8',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#b5a1c8',
        },
      },

    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };

  overdueByRegionPieChart: ZingchartAngular.graphset = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {
        backgroundColor: 'black',
        borderWidth: '0px',
        fontSize: '10px',
        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox:
      {
        type: 'all',
        text: '%t<br>%npv%',
        placement: 'out',
        fontSize: '10px'
      },

      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',

      slice: 60,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },
    series: [
      {
        text: 'East',
        values: [16541],
        backgroundColor: '#95ce50',
        lineColor: '#95ce50',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#95ce50',
        },
      },
      {
        text: 'West',
        values: [36711],
        backgroundColor: '#ffb300',
        lineColor: '#ffb300',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ffb300',
        },
      },
      {
        text: 'North',
        values: [50011],
        backgroundColor: '#ff6f00',
        lineColor: '#ff6f00',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#ff6f00',
        },
      },
      {
        text: 'South',
        values: [50011],
        backgroundColor: '#0071bd',
        lineColor: '#0071bd',
        lineWidth: '1px',
        marker: {
          backgroundColor: '#0071bd',
        },
      },

    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };

  transectionChart: ZingchartAngular.graphset = {
    type: "line",
    scaleX: {
      // labels: ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
      visible: false
    },
    scaleY: {
      visible: false
    },
    plot: {
      aspect: "spline",
    },
    series: [{
      values: this.transectionValue,
      monotone: true,
      text: "monotone: true"
    },

    ]
  }

  invoiceCollectionChart: any = {
    type: "line",
    scaleX: {
      // labels: ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
      "step": "86400000",
      "transform": {
        "type": "date",
        "all": "%d<br/>day"
      },
      "item": {
        "font-size": 9
      },
    },
    "tooltip": {
      "visible": false
    },
    plot: {
      aspect: "spline",
      "tooltip-text": "%t views: %v<br>%k",
      "shadow": 0,
      "line-width": "2px",
      "marker": {
        "type": "circle",
        "size": 3
      }
    },
    plotarea: {
      backgroundColor: 'transparent',
      marginTop: '20px',
    },
    "crosshair-x": {
      "line-color": "#efefef",
      "plot-label": {
        "border-radius": "5px",
        "border-width": "1px",
        "border-color": "#f6f7f8",
        "padding": "10px",
        "font-weight": "bold"
      },
      "scale-label": {
        "font-color": "#000",
        "background-color": "#f6f7f8",
        "border-radius": "5px"
      }
    },
    series: [{
      values: this.invoiceValue1,
      monotone: true,
      text: "Invoice",
      lineColor: '#0071bd',
      "marker": {
        "background-color": "#0071bd",
      },

    },
    {
      values: this.collectionValue1,
      monotone: true,
      text: "Collection",
      lineColor: '#6ec44d',
      "marker": {
        "background-color": "#6ec44d",
      },
      "highlight-state": {
        "line-width": 3
      },
    },

    ]
  }







  totalCouponPieChart: any = {
    type: 'ring',
    backgroundColor: '#fff',

    plot: {
      tooltip: {

        backgroundColor: '#000',
        borderWidth: '0px',
        fontSize: '10px',
        sticky: true,
        thousandsSeparator: ',',
      },
      valueBox:
      {
        type: 'all',
        text: '%npv%',
        placement: 'in',
        fontSize: '8px'
      },
      animation: {
        effect: 2,
        sequence: 3,
        speed: 1000
      },
      backgroundColor: '#FBFCFE',
      borderWidth: '0px',
      slice: 0,
    },
    plotarea: {
      margin: '0px',
      backgroundColor: 'transparent',
      borderRadius: '10px',
      borderWidth: '0px',
    },

    series: [
      {
        text: 'Item Count',
        values: [1000],
        backgroundColor: 'var(--primary-tint)',
        lineColor: 'var(--primary-tint)',
        lineWidth: '1px',
        marker: {
          backgroundColor: 'var(--primary-tint)',
        },
      },
      {
        text: 'Box Count',
        values: [50],
        backgroundColor: 'var(--primary-tint)',
        lineColor: 'var(--primary-tint)',
        lineWidth: '1px',
        marker: {
          backgroundColor: 'var(--primary-tint)',
        },
      },
    ],
    noData: {
      text: 'No Selection',
      alpha: 0.6,
      backgroundColor: '#20b2db',
      bold: true,
      fontSize: '10px',
      textAlpha: 0.9,
    },
  };










initializeMap(): void {
    // Demo data for check_in_data

    if (this.myMap) {
      this.myMap.off(); // Remove the existing map if it exists
      this.myMap.remove(); // Remove the existing map if it exists
    }

    // Set view to center of India with a zoom level that focuses on India
    this.myMap = L.map('map', {
      scrollWheelZoom: true, // Enable scroll wheel zoom
      dragging: true, // Enable dragging
      zoomControl: true // Show zoom controls
    }).setView([22.5937, 78.9629], 5); // Center coordinates of India with zoom level 5

    // Define multiple base layers
    const OSM = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 4, // Prevent zooming out too far
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    // Google Maps layers
    const googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      maxZoom: 22,
      minZoom: 4,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: '&copy; Google Maps'
    });

    const googleHybrid = L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
      maxZoom: 22,
      minZoom: 4,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: '&copy; Google Maps'
    });

    // Add OpenStreetMap as the default layer
    googleStreets.addTo(this.myMap);

    // Set max bounds to restrict panning to around India region
    const southWest = L.latLng(5.5, 65.0); // Southwest corner of bounds
    const northEast = L.latLng(37.0, 97.0); // Northeast corner of bounds
    const bounds = L.latLngBounds(southWest, northEast);
    this.myMap.setMaxBounds(bounds);

    this.check_in_data.forEach((point, index) => {
      const marker = L.marker([point.latestLat, point.latestLng]).addTo(this.myMap);
      marker.setIcon(L.icon({
        iconUrl: './assets/location/checkout.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        riseOnHover: true,
      }));

      marker.on('click', async () => {
        // Zoom to the marker location with high zoom level
        this.myMap.setView([point.latestLat, point.latestLng], 18, {
          animate: true,
          duration: 1.0 // Animation duration in seconds
        });

        // Show loading popup first
        marker.bindPopup(`<p><strong>Name:</strong> ${point.name} (${point.employee_id})<br/><strong>Address:</strong> Loading...</p>`).openPopup();

        // Get address
        this.serve.post_rqst({ id: point.id }, "Dashboard/getAddress")
          .subscribe((result) => {
            const address = result['latLngData']['address'];
            // Update popup with actual address
            marker.bindPopup(`<p><strong>Name:</strong> ${point.name} (${point.employee_id})<br/><strong>Address:</strong> ${address}</p>`).openPopup();
          });
      });
    });

    // Add layer control for switching between base maps
    var baseLayers = {
      "Streets": googleStreets,
      "OpenStreetMap": OSM,
      "Hybrid": googleHybrid,
    };

    L.control.layers(baseLayers).addTo(this.myMap);
}

getMapData() {
    this.mapLoader = true;
    this.serve.post_rqst({ data: this.data }, "Dashboard/getMapData")
      .subscribe((result => {
        this.check_in_data = result['latLngData'];

        setTimeout(() => {
          this.initializeMap();
          this.mapLoader = false;
        }, 3000);
      }));
    // Remove this line as it's setting mapLoader to false immediately
    // this.mapLoader = false;
}
 refresh(type){


    if(type=='attendanceDashboard')
   {
      this.attendanceStatus={}
    this.getAttendanceStatus();
   }

    if(type=='subDepartmentData')
   {
      this.subDepartmentDataStatus={}
    this.getsubDepartmentData();
   }
   if(type=='customerDashboard')
    {
      this.CustomerVisits={}
     this.getCustomerVisits();
    }
    if(type=='focusDashboard')
      {
         this.FocusVisits={}
        this.getFocusVisits();
      }
      if(type=='customerNetworkDashboard')
        {
          this.CustomerNetwork={}
          this.getCustomerNetwork()
        }
 }


   reportingTwo:any = [];
  getAllList(state, rsm1, rsm2, hod,hod_id) {
    this.serve.post_rqst({ 'state': state, 'rsm1': rsm1, 'rsm2': rsm2, 'hod': hod ,'hod_id': hod_id?hod_id:this.data.hod_reporting,filterType:"dashboard"}, "Reports/fetchFilterData").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.states = result['result']['state'];
        this.hod = result['result']['hod'];
        this.reportingTwo = result['result']['rm2'];
        this.reportingOne = result['result']['rm1'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }

  allSelect(type) {
    if (type == "state") {
      setTimeout(() => {
        if (this.data.checkUser == true) {
          const array = [];
          for (let i = 0; i < this.states.length; i++) {
            array.push(this.states[i].state_name);
          }
          this.data.state = array.map(String);
        }
        else {
          this.data.state = '';
          this.data.assigned_sales_user_name = '';
        }

      }, 50);
    }
    else if (type == "rm1") {
      setTimeout(() => {
        if (this.data.rm1 == true) {
          const array = [];
          for (let i = 0; i < this.reportingOne.length; i++) {
            array.push(this.reportingOne[i].id);
          }
          this.data.rsm1 = array.map(String);
        }
        else {
          this.data.rsm1 = '';
          this.data.assigned_sales_user_name = '';

        }

      }, 50);
    }

    else if (type == "rm2") {

      setTimeout(() => {
        if (this.data.rm2 == true) {
          const array = [];
          for (let i = 0; i < this.reportingTwo.length; i++) {
            array.push(this.reportingTwo[i].rsm2_id);
          }
          this.data.rsm2 = array.map(String);
        }
        else {
          this.data.rsm2 = '';
          this.data.assigned_sales_user_name = '';

        }

      }, 50);
    }

    else if (type == "hod_user") {
      setTimeout(() => {
        if (this.data.hod_user == true) {
          const array = [];
          for (let i = 0; i < this.hod.length; i++) {
            array.push(this.hod[i].hod_id);
          }
          this.data.hod_reporting = array.map(String);
        }
        else {
          this.data.hod_reporting = '';
          this.data.assigned_sales_user_name = '';

        }
      }, 50);
    }
    else {
      setTimeout(() => {
        if (this.data.employee == true) {
          const array = [];
          for (let i = 0; i < this.user.length; i++) {
            array.push(this.user[i].id);
          }
          this.data.assigned_sales_user_name = array.map(String);
        }
        else {
          this.data.assigned_sales_user_name = '';
        }
      }, 50);
    }
  }



  userList(search,hod_reporting) {
    console.log(this.data.hod_reporting,'data.hod_reporting');


    this.serve.post_rqst({ 'state': this.data.state, 'rm1': this.data.rsm1, 'rm2': this.data.rsm2, 'hod':this.data.hod_reporting, 'hod_id': hod_reporting?hod_reporting:this.data.hod_reporting, 'search': search ,filterType:"dashboard"}, "Reports/fetchFilterUserData").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.user = result['result'];
        const userData = [];
        if (this.data.state || this.data.rsm1 || this.data.rsm2 || this.data.hod_reporting) {
          for (let i = 0; i < this.user.length; i++) {
            userData.push(this.user[i].id);
          }
          this.data.assigned_sales_user_name = userData.map(String);
        }
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }

  ClearFilter(action: any = '') {
    if (action == "refresh") {
      this.savingFlag = true;
      this.data = {};
      this.savingFlag = false;
    }
  }
}
